var map = {
	"./Agriculture/002-animal feed.svg": 786,
	"./Agriculture/003-axe.svg": 787,
	"./Agriculture/004-barn.svg": 788,
	"./Agriculture/009-chicken.svg": 789,
	"./Agriculture/010-corn.svg": 790,
	"./Agriculture/011-shovel.svg": 791,
	"./Agriculture/014-farmer.svg": 792,
	"./Agriculture/015-fence.svg": 793,
	"./Agriculture/017-haystack.svg": 794,
	"./Agriculture/018-house.svg": 795,
	"./Agriculture/020-pickup truck.svg": 796,
	"./Agriculture/022-seed bag.svg": 797,
	"./Agriculture/025-sprouts.svg": 798,
	"./Agriculture/026-tractor.svg": 799,
	"./Agriculture/027-vegetables.svg": 800,
	"./Agriculture/030-water well.svg": 801,
	"./AlphaNum/001-A.svg": 423,
	"./AlphaNum/002-b.svg": 424,
	"./AlphaNum/003-c.svg": 425,
	"./AlphaNum/004-d.svg": 426,
	"./AlphaNum/005-e.svg": 427,
	"./AlphaNum/006-f.svg": 428,
	"./AlphaNum/007-g.svg": 429,
	"./AlphaNum/008-h.svg": 430,
	"./AlphaNum/009-I.svg": 431,
	"./AlphaNum/010-j.svg": 432,
	"./AlphaNum/011-k.svg": 433,
	"./AlphaNum/012-l.svg": 434,
	"./AlphaNum/013-m.svg": 435,
	"./AlphaNum/014-n.svg": 436,
	"./AlphaNum/015-o.svg": 437,
	"./AlphaNum/016-p.svg": 438,
	"./AlphaNum/017-q.svg": 439,
	"./AlphaNum/018-r.svg": 440,
	"./AlphaNum/019-s.svg": 441,
	"./AlphaNum/020-t.svg": 442,
	"./AlphaNum/021-u.svg": 443,
	"./AlphaNum/022-v.svg": 444,
	"./AlphaNum/023-w.svg": 445,
	"./AlphaNum/024-x.svg": 446,
	"./AlphaNum/025-y.svg": 447,
	"./AlphaNum/026-z.svg": 448,
	"./AlphaNum/027-0.svg": 449,
	"./AlphaNum/027-one.svg": 450,
	"./AlphaNum/028-1.svg": 451,
	"./AlphaNum/028-zero.svg": 452,
	"./AlphaNum/029-2.svg": 453,
	"./AlphaNum/029-two.svg": 454,
	"./AlphaNum/030-3.svg": 455,
	"./AlphaNum/030-three.svg": 456,
	"./AlphaNum/031-4.svg": 457,
	"./AlphaNum/031-four.svg": 458,
	"./AlphaNum/032-5.svg": 459,
	"./AlphaNum/032-five.svg": 460,
	"./AlphaNum/033-6.svg": 461,
	"./AlphaNum/033-six.svg": 462,
	"./AlphaNum/034-7.svg": 463,
	"./AlphaNum/034-seven.svg": 464,
	"./AlphaNum/035-8.svg": 465,
	"./AlphaNum/035-eight.svg": 466,
	"./AlphaNum/036-9.svg": 467,
	"./AlphaNum/036-nine.svg": 468,
	"./AmusementPark/003-bumper car.svg": 802,
	"./AmusementPark/004-carousel.svg": 803,
	"./AmusementPark/006-circus.svg": 804,
	"./AmusementPark/007-clown.svg": 805,
	"./AmusementPark/008-fair ship.svg": 806,
	"./AmusementPark/009-ferris wheel.svg": 807,
	"./AmusementPark/010-float.svg": 808,
	"./AmusementPark/015-pedal boat.svg": 809,
	"./AmusementPark/018-roller coaster.svg": 810,
	"./AmusementPark/019-shooting gallery.svg": 811,
	"./AmusementPark/021-swing.svg": 812,
	"./AmusementPark/023-ticket office.svg": 813,
	"./AmusementPark/025-toboggan.svg": 814,
	"./AmusementPark/027-toy machine.svg": 815,
	"./AmusementPark/029-unicycle.svg": 816,
	"./AmusementPark/030-water slide.svg": 817,
	"./Animal1/001-ant.svg": 818,
	"./Animal1/002-anteater.svg": 819,
	"./Animal1/003-arctic fox.svg": 820,
	"./Animal1/004-bear.svg": 821,
	"./Animal1/009-camel.svg": 822,
	"./Animal1/010-cat.svg": 823,
	"./Animal1/011-chameleon.svg": 824,
	"./Animal1/012-cheetah.svg": 825,
	"./Animal1/017-crab.svg": 826,
	"./Animal1/018-crocodile.svg": 827,
	"./Animal1/019-deer.svg": 828,
	"./Animal1/020-dog.svg": 829,
	"./Animal1/025-emu.svg": 830,
	"./Animal1/026-flamingo.svg": 831,
	"./Animal1/027-fox.svg": 832,
	"./Animal1/028-frog.svg": 833,
	"./Animal2/029-panda bear.svg": 834,
	"./Animal2/030-giraffe.svg": 835,
	"./Animal2/031-goat.svg": 836,
	"./Animal2/032-gorilla.svg": 837,
	"./Animal2/033-guinea pig.svg": 838,
	"./Animal2/034-hamster.svg": 839,
	"./Animal2/035-hedgehog.svg": 840,
	"./Animal2/036-hippopotamus.svg": 841,
	"./Animal2/037-horse.svg": 842,
	"./Animal2/038-hummingbird.svg": 843,
	"./Animal2/039-jaguar.svg": 844,
	"./Animal2/040-jellyfish.svg": 845,
	"./Animal2/041-kangaroo.svg": 846,
	"./Animal2/042-orca.svg": 847,
	"./Animal2/043-kiwi.svg": 848,
	"./Animal2/044-koala.svg": 849,
	"./Animal3/045-ladybug.svg": 850,
	"./Animal3/046-lemur.svg": 851,
	"./Animal3/047-leopard.svg": 852,
	"./Animal3/048-lion.svg": 853,
	"./Animal3/049-llama.svg": 854,
	"./Animal3/050-lobster.svg": 855,
	"./Animal3/051-monkey.svg": 856,
	"./Animal3/052-mouse.svg": 857,
	"./Animal3/053-octopus.svg": 858,
	"./Animal3/054-orangutan.svg": 859,
	"./Animal3/055-ostrich.svg": 860,
	"./Animal3/056-otter.svg": 861,
	"./Animal3/057-owl.svg": 862,
	"./Animal3/058-black panther.svg": 863,
	"./Animal3/059-peacock.svg": 864,
	"./Animal3/060-penguin.svg": 865,
	"./Animal4/061-pig.svg": 866,
	"./Animal4/062-pigeon.svg": 867,
	"./Animal4/063-platypus.svg": 868,
	"./Animal4/064-polar bear.svg": 869,
	"./Animal4/069-rabbit.svg": 870,
	"./Animal4/070-raccoon.svg": 871,
	"./Animal4/071-rat.svg": 872,
	"./Animal4/072-red panda.svg": 873,
	"./Animal4/077-seahorse.svg": 874,
	"./Animal4/078-seal.svg": 875,
	"./Animal4/079-shark.svg": 876,
	"./Animal4/080-sheep.svg": 877,
	"./Animal4/085-spider.svg": 878,
	"./Animal4/086-squirrel.svg": 879,
	"./Animal4/087-starfish.svg": 880,
	"./Animal4/088-manta ray.svg": 881,
	"./Animal5/065-porcupine.svg": 882,
	"./Animal5/066-prawn.svg": 883,
	"./Animal5/067-praying mantis.svg": 884,
	"./Animal5/068-puffer fish.svg": 885,
	"./Animal5/073-reindeer.svg": 886,
	"./Animal5/074-rhinoceros.svg": 887,
	"./Animal5/083-snail.svg": 888,
	"./Animal5/084-snake.svg": 889,
	"./Animal5/090-swan.svg": 890,
	"./Animal5/091-tiger.svg": 891,
	"./Animal5/094-turkey.svg": 892,
	"./Animal5/095-turtle.svg": 893,
	"./Animal5/097-whale.svg": 894,
	"./Animal5/098-wolf.svg": 895,
	"./Animal5/099-yak.svg": 896,
	"./Animal5/100-zebra.svg": 897,
	"./Architecture/001-blueprint.svg": 898,
	"./Architecture/002-crane.svg": 899,
	"./Architecture/006-greek pillars.svg": 900,
	"./Architecture/008-arc.svg": 901,
	"./Architecture/012-Skyscrapper.svg": 902,
	"./Architecture/014-bridge.svg": 903,
	"./Architecture/018-colonnade.svg": 904,
	"./Architecture/023-gate.svg": 905,
	"./Architecture/030-measuring tape.svg": 906,
	"./Architecture/031-square ruler.svg": 907,
	"./Architecture/037-parthenon.svg": 908,
	"./Architecture/038-beam.svg": 909,
	"./Architecture/041-cornice.svg": 910,
	"./Architecture/042-stairs.svg": 911,
	"./Architecture/048-fountain.svg": 912,
	"./Architecture/050-floor.svg": 913,
	"./Arts1/001-painting.svg": 914,
	"./Arts1/003-sculpture.svg": 915,
	"./Arts1/004-ceramics.svg": 916,
	"./Arts1/005-graphic design.svg": 917,
	"./Arts1/006-photography.svg": 918,
	"./Arts1/007-fashion design.svg": 919,
	"./Arts1/008-interior design.svg": 920,
	"./Arts1/009-architecture.svg": 921,
	"./Arts1/011-woodworking.svg": 922,
	"./Arts1/012-jewelry.svg": 923,
	"./Arts1/014-video games.svg": 924,
	"./Arts1/015-magician.svg": 925,
	"./Arts1/016-singer.svg": 926,
	"./Arts1/017-opera.svg": 927,
	"./Arts1/019-musician.svg": 928,
	"./Arts1/020-ballet.svg": 929,
	"./Arts2/025-literature.svg": 930,
	"./Arts2/026-poetry.svg": 931,
	"./Arts2/028-politics.svg": 932,
	"./Arts2/029-history.svg": 933,
	"./Arts2/030-anthropology.svg": 934,
	"./Arts2/032-religion.svg": 935,
	"./Arts2/033-psychology.svg": 936,
	"./Arts2/034-geography.svg": 937,
	"./Arts2/035-cartography.svg": 938,
	"./Arts2/036-astronomy.svg": 939,
	"./Arts2/037-statistics.svg": 940,
	"./Arts2/041-chemistry.svg": 941,
	"./Arts2/042-biologist.svg": 942,
	"./Arts2/043-botany.svg": 943,
	"./Arts2/044-sociology.svg": 944,
	"./Arts2/047-calligraphy.svg": 945,
	"./Auction/001-house.svg": 946,
	"./Auction/002-necklace.svg": 947,
	"./Auction/005-painting.svg": 948,
	"./Auction/006-diamond.svg": 949,
	"./Auction/007-catalogue.svg": 950,
	"./Auction/010-wristwatch.svg": 951,
	"./Auction/013-Bid.svg": 952,
	"./Auction/016-certificate.svg": 953,
	"./Auction/018-statue.svg": 954,
	"./Auction/023-vase.svg": 955,
	"./Auction/026-diamond ring.svg": 956,
	"./Auction/032-car.svg": 957,
	"./Auction/035-cctv camera.svg": 958,
	"./Auction/042-tuxedo.svg": 959,
	"./Auction/046-charity.svg": 960,
	"./Auction/050-safety box.svg": 961,
	"./Australia/003-Sydney Tower.svg": 962,
	"./Australia/004-wine.svg": 963,
	"./Australia/006-kangaroo.svg": 964,
	"./Australia/007-turtle.svg": 965,
	"./Australia/011-flip flops.svg": 966,
	"./Australia/013-emu.svg": 967,
	"./Australia/014-platypus.svg": 968,
	"./Australia/016-Australia.svg": 969,
	"./Australia/017-lighthouse.svg": 970,
	"./Australia/020-Sydney Opera House.svg": 971,
	"./Australia/024-sailboat.svg": 972,
	"./Australia/027-koala.svg": 973,
	"./Australia/032-rugby.svg": 974,
	"./Australia/041-kiwi.svg": 975,
	"./Australia/042-boomerang.svg": 976,
	"./Australia/043-wool.svg": 977,
	"./Autumn/004-turkey.svg": 978,
	"./Autumn/005-acorn.svg": 979,
	"./Autumn/006-mushroom.svg": 980,
	"./Autumn/008-tree.svg": 981,
	"./Autumn/010-corn.svg": 982,
	"./Autumn/011-pumpkin.svg": 983,
	"./Autumn/014-scarf.svg": 984,
	"./Autumn/015-socks.svg": 985,
	"./Autumn/016-campfire.svg": 986,
	"./Autumn/020-wool hat.svg": 987,
	"./Autumn/024-fox.svg": 988,
	"./Autumn/027-sweater.svg": 989,
	"./Autumn/029-squirrel.svg": 990,
	"./Autumn/031-apple.svg": 991,
	"./Autumn/032-hedgehog.svg": 992,
	"./Autumn/035-pine cone.svg": 993,
	"./Bakery/006-egg.svg": 994,
	"./Bakery/007-apron.svg": 995,
	"./Bakery/009-knife.svg": 996,
	"./Bakery/010-bakery.svg": 997,
	"./Bakery/011-glove.svg": 998,
	"./Bakery/012-cake-1.svg": 999,
	"./Bakery/015-measuring spoon.svg": 1000,
	"./Bakery/016-pizza cutter.svg": 1001,
	"./Bakery/022-milk.svg": 1002,
	"./Bakery/034-cupcake.svg": 1003,
	"./Bakery/035-pie.svg": 1004,
	"./Bakery/037-flour.svg": 1005,
	"./Bakery/039-cooking pot.svg": 1006,
	"./Bakery/040-oven.svg": 1007,
	"./Bakery/048-baker.svg": 1008,
	"./Bakery/049-mixer.svg": 1009,
	"./Baubles/01-bauble.svg": 1010,
	"./Baubles/02-bauble.svg": 1011,
	"./Baubles/03-bauble.svg": 1012,
	"./Baubles/04-bauble.svg": 1013,
	"./Baubles/05-bauble.svg": 1014,
	"./Baubles/06-bauble.svg": 1015,
	"./Beverage1/009-energy drink.svg": 1016,
	"./Beverage1/010-cappuccino.svg": 1017,
	"./Beverage1/011-cola.svg": 1018,
	"./Beverage1/013-matcha.svg": 1019,
	"./Beverage1/014-chocolate milk.svg": 1020,
	"./Beverage1/015-mimosa.svg": 1021,
	"./Beverage1/016-soda.svg": 1022,
	"./Beverage1/017-sangria.svg": 1023,
	"./Beverage1/018-beer.svg": 1024,
	"./Beverage1/019-lemonade.svg": 1025,
	"./Beverage1/020-tea.svg": 1026,
	"./Beverage1/021-milkshake.svg": 1027,
	"./Beverage1/022-coffee.svg": 1028,
	"./Beverage1/023-bubble tea.svg": 1029,
	"./Beverage1/024-mojito.svg": 1030,
	"./Beverage1/032-milkshake.svg": 1031,
	"./Beverage2/003-coffee.svg": 1032,
	"./Beverage2/004-wine.svg": 1033,
	"./Beverage2/006-champagne.svg": 1034,
	"./Beverage2/007-martini.svg": 1035,
	"./Beverage2/025-latte macchiato.svg": 1036,
	"./Beverage2/030-beer.svg": 1037,
	"./Beverage2/031-milk.svg": 1038,
	"./Beverage2/033-strawberry milk.svg": 1039,
	"./Beverage2/034-whiskey.svg": 1040,
	"./Beverage2/037-iced coffee.svg": 1041,
	"./Beverage2/039-cocktail.svg": 1042,
	"./Beverage2/042-punch.svg": 1043,
	"./Beverage2/044-coconut.svg": 1044,
	"./Beverage2/045-margarita.svg": 1045,
	"./Beverage2/046-hot chocolate.svg": 1046,
	"./Beverage2/050-orange juice.svg": 1047,
	"./Canada/001-Canadian flag.svg": 1048,
	"./Canada/002-maple leaf.svg": 1049,
	"./Canada/003-hat.svg": 1050,
	"./Canada/004-maple syrup.svg": 1051,
	"./Canada/005-moose.svg": 1052,
	"./Canada/007-pancakes.svg": 1053,
	"./Canada/009-bear.svg": 1054,
	"./Canada/010-hockey equipment.svg": 1055,
	"./Canada/012-beaver.svg": 1056,
	"./Canada/013-totem.svg": 1057,
	"./Canada/015-teepee.svg": 1058,
	"./Canada/019-curling.svg": 1059,
	"./Canada/021-kayak.svg": 1060,
	"./Canada/022-acorn.svg": 1061,
	"./Canada/024-mountain.svg": 1062,
	"./Canada/029-hat.svg": 1063,
	"./Casino/001-croupier.svg": 1064,
	"./Casino/002-cctv.svg": 1065,
	"./Casino/003-alarm.svg": 1066,
	"./Casino/006-card games.svg": 1067,
	"./Casino/011-cocktail.svg": 1068,
	"./Casino/012-target.svg": 1069,
	"./Casino/014-dice.svg": 1070,
	"./Casino/015-casino chip.svg": 1071,
	"./Casino/017-elegant.svg": 1072,
	"./Casino/019-dart.svg": 1073,
	"./Casino/020-lottery.svg": 1074,
	"./Casino/021-snooker.svg": 1075,
	"./Casino/023-roulette.svg": 1076,
	"./Casino/025-slot machine.svg": 1077,
	"./Casino/027-cigar.svg": 1078,
	"./Casino/030-poker machine.svg": 1079,
	"./Chemistry/002-dropper.svg": 1080,
	"./Chemistry/004-clamp.svg": 1081,
	"./Chemistry/006-brush.svg": 1082,
	"./Chemistry/008-mortar.svg": 1083,
	"./Chemistry/013-poison.svg": 1084,
	"./Chemistry/015-flask.svg": 1085,
	"./Chemistry/017-erlemeyer flask.svg": 1086,
	"./Chemistry/019-stand.svg": 1087,
	"./Chemistry/020-microscope.svg": 1088,
	"./Chemistry/024-thermometer.svg": 1089,
	"./Chemistry/025-retort.svg": 1090,
	"./Chemistry/030-funnel.svg": 1091,
	"./Chemistry/033-test tube.svg": 1092,
	"./Chemistry/038-syringe.svg": 1093,
	"./Chemistry/040-periodic table.svg": 1094,
	"./Chemistry/049-buret.svg": 1095,
	"./China/001-yin yang.svg": 1096,
	"./China/005-fan.svg": 1097,
	"./China/006-lantern.svg": 1098,
	"./China/009-bamboo.svg": 1099,
	"./China/011-chinese knot.svg": 1100,
	"./China/013-panda.svg": 1101,
	"./China/014-vase.svg": 1102,
	"./China/016-silk.svg": 1103,
	"./China/020-firecracker.svg": 1104,
	"./China/021-dumpling.svg": 1105,
	"./China/026-calligraphy.svg": 1106,
	"./China/032-red envelope.svg": 1107,
	"./China/035-oriental pearl tower.svg": 1108,
	"./China/038-forbidden city.svg": 1109,
	"./China/039-great wall of china.svg": 1110,
	"./China/044-teapot.svg": 1111,
	"./ChineseNewYear/001-badge.svg": 1112,
	"./ChineseNewYear/002-bonsai.svg": 1113,
	"./ChineseNewYear/003-drum.svg": 1114,
	"./ChineseNewYear/005-firework.svg": 1115,
	"./ChineseNewYear/006-firecracker.svg": 1116,
	"./ChineseNewYear/009-orange.svg": 1117,
	"./ChineseNewYear/013-incense.svg": 1118,
	"./ChineseNewYear/015-gold ingot.svg": 1119,
	"./ChineseNewYear/016-chicken.svg": 1120,
	"./ChineseNewYear/017-dumpling.svg": 1121,
	"./ChineseNewYear/019-god of wealth.svg": 1122,
	"./ChineseNewYear/021-gate.svg": 1123,
	"./ChineseNewYear/026-red envelope.svg": 1124,
	"./ChineseNewYear/028-amulet.svg": 1125,
	"./ChineseNewYear/029-peach.svg": 1126,
	"./ChineseNewYear/030-lantern.svg": 1127,
	"./Christmas/003-postcard.svg": 1128,
	"./Christmas/004-santa hat.svg": 1129,
	"./Christmas/006-gingerbread man.svg": 1130,
	"./Christmas/007-mitten.svg": 1131,
	"./Christmas/008-wreath.svg": 1132,
	"./Christmas/009-candy cane.svg": 1133,
	"./Christmas/012-snowflake.svg": 1134,
	"./Christmas/016-snowman.svg": 1135,
	"./Christmas/018-Christmas tree.svg": 1136,
	"./Christmas/019-Santa Claus.svg": 1137,
	"./Christmas/022-candy.svg": 1138,
	"./Christmas/023-fireplace.svg": 1139,
	"./Christmas/025-ribbon.svg": 1140,
	"./Christmas/026-lollipop.svg": 1141,
	"./Christmas/029-stocking.svg": 1142,
	"./Christmas/031-reindeer.svg": 1143,
	"./Christmas/033-bell.svg": 1144,
	"./Christmas/036-candle.svg": 1145,
	"./Christmas/037-angel.svg": 1146,
	"./Christmas/040-gift.svg": 1147,
	"./CityElements/002-carousel.svg": 1148,
	"./CityElements/005-bridge.svg": 1149,
	"./CityElements/007-bus stop.svg": 1150,
	"./CityElements/009-crosswalk.svg": 1151,
	"./CityElements/010-fast food.svg": 1152,
	"./CityElements/011-free wifi.svg": 1153,
	"./CityElements/012-gas station.svg": 1154,
	"./CityElements/014-gym.svg": 1155,
	"./CityElements/015-hospital.svg": 1156,
	"./CityElements/016-hostel.svg": 1157,
	"./CityElements/020-parking lot.svg": 1158,
	"./CityElements/021-park.svg": 1159,
	"./CityElements/023-phone booth.svg": 1160,
	"./CityElements/026-street.svg": 1161,
	"./CityElements/028-traffic light.svg": 1162,
	"./CityElements/030-vending machine.svg": 1163,
	"./ClimateChange/001-carbon dioxide.svg": 1164,
	"./ClimateChange/004-acid rain.svg": 1165,
	"./ClimateChange/005-air pollution.svg": 1166,
	"./ClimateChange/008-deforestation.svg": 1167,
	"./ClimateChange/010-drought.svg": 1168,
	"./ClimateChange/014-eartquake.svg": 1169,
	"./ClimateChange/015-ecosystem.svg": 1170,
	"./ClimateChange/016-flood.svg": 1171,
	"./ClimateChange/017-global warming.svg": 1172,
	"./ClimateChange/018-greenhouse effect.svg": 1173,
	"./ClimateChange/021-landslide.svg": 1174,
	"./ClimateChange/026-pollution.svg": 1175,
	"./ClimateChange/027-sea level.svg": 1176,
	"./ClimateChange/028-sewer.svg": 1177,
	"./ClimateChange/029-tsunami.svg": 1178,
	"./ClimateChange/030-volcano.svg": 1179,
	"./Clothes1/001-overalls.svg": 1180,
	"./Clothes1/003-hoodie.svg": 1181,
	"./Clothes1/004-dress.svg": 1182,
	"./Clothes1/005-shirt.svg": 1183,
	"./Clothes1/006-sweater.svg": 1184,
	"./Clothes1/007-tshirt.svg": 1185,
	"./Clothes1/008-long coat.svg": 1186,
	"./Clothes1/009-pants.svg": 1187,
	"./Clothes1/010-kimono.svg": 1188,
	"./Clothes1/011-sport bra.svg": 1189,
	"./Clothes1/012-dress.svg": 1190,
	"./Clothes1/013-denim jacket.svg": 1191,
	"./Clothes1/014-bikini.svg": 1192,
	"./Clothes1/016-underwear.svg": 1193,
	"./Clothes1/049-puffer coat.svg": 1194,
	"./Clothes1/050-puffer.svg": 1195,
	"./Clothes2/017-vest.svg": 1196,
	"./Clothes2/018-varsity.svg": 1197,
	"./Clothes2/019-boxer.svg": 1198,
	"./Clothes2/022-pajamas.svg": 1199,
	"./Clothes2/025-ripped jeans.svg": 1200,
	"./Clothes2/026-polo shirt.svg": 1201,
	"./Clothes2/028-summer shirt.svg": 1202,
	"./Clothes2/030-tiered skirt.svg": 1203,
	"./Clothes2/031-jogger pants.svg": 1204,
	"./Clothes2/034-dress.svg": 1205,
	"./Clothes2/036-bathrobe.svg": 1206,
	"./Clothes2/039-parka.svg": 1207,
	"./Clothes2/040-Turtleneck.svg": 1208,
	"./Clothes2/041-cardigan.svg": 1209,
	"./Clothes2/042-pants.svg": 1210,
	"./Clothes2/043-suit.svg": 1211,
	"./Computer1/002-monitor.svg": 1212,
	"./Computer1/003-server.svg": 1213,
	"./Computer1/005-laptop.svg": 1214,
	"./Computer1/006-wireless keyboard.svg": 1215,
	"./Computer1/007-wireless mouse.svg": 1216,
	"./Computer1/008-printer.svg": 1217,
	"./Computer1/009-flash disk.svg": 1218,
	"./Computer1/010-desktop computer.svg": 1219,
	"./Computer1/012-wifi router.svg": 1220,
	"./Computer1/013-Ram Memory.svg": 1221,
	"./Computer1/014-harddisk.svg": 1222,
	"./Computer1/022-tablet.svg": 1223,
	"./Computer1/025-cpu.svg": 1224,
	"./Computer1/037-speaker.svg": 1225,
	"./Computer1/047-smartphone.svg": 1226,
	"./Computer1/050-power supply.svg": 1227,
	"./Computer2/001-settings.svg": 1228,
	"./Computer2/004-cloud computing.svg": 1229,
	"./Computer2/011-speedometer.svg": 1230,
	"./Computer2/016-coding.svg": 1231,
	"./Computer2/018-antivirus.svg": 1232,
	"./Computer2/020-web browser.svg": 1233,
	"./Computer2/023-data recovery.svg": 1234,
	"./Computer2/024-archive.svg": 1235,
	"./Computer2/029-accounts.svg": 1236,
	"./Computer2/030-translation.svg": 1237,
	"./Computer2/033-statistics.svg": 1238,
	"./Computer2/034-message.svg": 1239,
	"./Computer2/035-repair.svg": 1240,
	"./Computer2/042-search.svg": 1241,
	"./Computer2/043-presentation.svg": 1242,
	"./Computer2/048-warning sign.svg": 1243,
	"./Cooking1/001-chef hat.svg": 1244,
	"./Cooking1/002-cutlery.svg": 1245,
	"./Cooking1/003-chopping board.svg": 1246,
	"./Cooking1/004-microwave oven.svg": 1247,
	"./Cooking1/013-glove.svg": 1248,
	"./Cooking1/014-recipe book.svg": 1249,
	"./Cooking1/015-frying pan.svg": 1250,
	"./Cooking1/016-bowl.svg": 1251,
	"./Cooking1/027-blender.svg": 1252,
	"./Cooking1/028-toaster.svg": 1253,
	"./Cooking1/029-grill.svg": 1254,
	"./Cooking1/030-mixer.svg": 1255,
	"./Cooking1/038-butcher.svg": 1256,
	"./Cooking1/046-electric kettle.svg": 1257,
	"./Cooking1/047-spoon.svg": 1258,
	"./Cooking1/048-peeler.svg": 1259,
	"./Cooking2/005-measuring cup.svg": 1260,
	"./Cooking2/008-apron.svg": 1261,
	"./Cooking2/009-weight scale.svg": 1262,
	"./Cooking2/012-knife.svg": 1263,
	"./Cooking2/017-gas stove.svg": 1264,
	"./Cooking2/018-rolling pin.svg": 1265,
	"./Cooking2/019-water glass.svg": 1266,
	"./Cooking2/020-pot.svg": 1267,
	"./Cooking2/021-electric mixer.svg": 1268,
	"./Cooking2/031-tea cup.svg": 1269,
	"./Cooking2/032-BBQ grill.svg": 1270,
	"./Cooking2/035-juicer.svg": 1271,
	"./Cooking2/036-trash can.svg": 1272,
	"./Cooking2/042-pizza cutter.svg": 1273,
	"./Cooking2/044-whisk.svg": 1274,
	"./Cooking2/045-pressure cooker.svg": 1275,
	"./Covid19/008-wear glasses.svg": 1276,
	"./Covid19/010-wear gloves.svg": 1277,
	"./Covid19/011-touch eyes.svg": 1278,
	"./Covid19/015-travel.svg": 1279,
	"./Covid19/024-wash hands.svg": 1280,
	"./Covid19/026-gather.svg": 1281,
	"./Covid19/027-drive car.svg": 1282,
	"./Covid19/029-touch nose.svg": 1283,
	"./Covid19/037-stay home.svg": 1284,
	"./Covid19/039-shop in mall.svg": 1285,
	"./Covid19/040-use soap.svg": 1286,
	"./Covid19/044-use handkerchief.svg": 1287,
	"./Covid19/045-take public transport.svg": 1288,
	"./Covid19/047-handshake.svg": 1289,
	"./Covid19/048-use cash.svg": 1290,
	"./Covid19/050-wear face mask.svg": 1291,
	"./CuteAnimal/003-cat.svg": 1292,
	"./CuteAnimal/004-cow.svg": 1293,
	"./CuteAnimal/005-puppy.svg": 1294,
	"./CuteAnimal/006-elephant.svg": 1295,
	"./CuteAnimal/007-emu.svg": 1296,
	"./CuteAnimal/009-giraffe.svg": 1297,
	"./CuteAnimal/013-koala.svg": 1298,
	"./CuteAnimal/015-lion.svg": 1299,
	"./CuteAnimal/016-monkey.svg": 1300,
	"./CuteAnimal/017-panda.svg": 1301,
	"./CuteAnimal/018-peacock.svg": 1302,
	"./CuteAnimal/019-penguin.svg": 1303,
	"./CuteAnimal/023-seal.svg": 1304,
	"./CuteAnimal/026-sloth.svg": 1305,
	"./CuteAnimal/029-walrus.svg": 1306,
	"./CuteAnimal/030-whale.svg": 1307,
	"./CuteAnimalHead/001-bear.svg": 1308,
	"./CuteAnimalHead/004-cat.svg": 1309,
	"./CuteAnimalHead/005-cow.svg": 1310,
	"./CuteAnimalHead/006-deer.svg": 1311,
	"./CuteAnimalHead/007-dog.svg": 1312,
	"./CuteAnimalHead/008-elephant.svg": 1313,
	"./CuteAnimalHead/009-fox.svg": 1314,
	"./CuteAnimalHead/011-goat.svg": 1315,
	"./CuteAnimalHead/012-gorilla.svg": 1316,
	"./CuteAnimalHead/013-hippopotamus.svg": 1317,
	"./CuteAnimalHead/014-horse.svg": 1318,
	"./CuteAnimalHead/016-koala.svg": 1319,
	"./CuteAnimalHead/017-lion.svg": 1320,
	"./CuteAnimalHead/018-monkey.svg": 1321,
	"./CuteAnimalHead/019-panda.svg": 1322,
	"./CuteAnimalHead/020-pig.svg": 1323,
	"./CuteAnimalHead/021-rabbit.svg": 1324,
	"./CuteAnimalHead/022-rhino.svg": 1325,
	"./CuteAnimalHead/023-snake.svg": 1326,
	"./CuteAnimalHead/024-tiger.svg": 1327,
	"./CuteAnimalHead/025-walrus.svg": 1328,
	"./CuteAppliance/002-smartwatch.svg": 1329,
	"./CuteAppliance/011-computer.svg": 1330,
	"./CuteAppliance/015-gameboy.svg": 1331,
	"./CuteAppliance/016-microwave.svg": 1332,
	"./CuteAppliance/017-toaster.svg": 1333,
	"./CuteAppliance/022-washing machine.svg": 1334,
	"./CuteAppliance/027-camera.svg": 1335,
	"./CuteAppliance/029-tv.svg": 1336,
	"./CuteAppliance/031-graphic tablet.svg": 1337,
	"./CuteAppliance/036-printer.svg": 1338,
	"./CuteAppliance/037-oven.svg": 1339,
	"./CuteAppliance/041-mobile.svg": 1340,
	"./CuteAppliance/045-fan.svg": 1341,
	"./CuteAppliance/055-light bulb.svg": 1342,
	"./CuteAppliance/057-router.svg": 1343,
	"./CuteAppliance/058-sd card.svg": 1344,
	"./DailyRoutine/002-watering.svg": 1345,
	"./DailyRoutine/003-basin.svg": 1346,
	"./DailyRoutine/005-wake up.svg": 1347,
	"./DailyRoutine/012-shower.svg": 1348,
	"./DailyRoutine/020-reading.svg": 1349,
	"./DailyRoutine/021-toilet.svg": 1350,
	"./DailyRoutine/027-workout.svg": 1351,
	"./DailyRoutine/028-work.svg": 1352,
	"./DailyRoutine/029-mop.svg": 1353,
	"./DailyRoutine/032-jogging.svg": 1354,
	"./DailyRoutine/035-hair brush.svg": 1355,
	"./DailyRoutine/037-school.svg": 1356,
	"./DailyRoutine/038-washing face.svg": 1357,
	"./DailyRoutine/040-washing dishes.svg": 1358,
	"./DailyRoutine/041-cooking.svg": 1359,
	"./DailyRoutine/046-calendar.svg": 1360,
	"./Dessert/002-cotton candy.svg": 1361,
	"./Dessert/004-cupcake.svg": 1362,
	"./Dessert/005-cookies.svg": 1363,
	"./Dessert/006-pancakes.svg": 1364,
	"./Dessert/009-pretzel.svg": 1365,
	"./Dessert/010-Jello.svg": 1366,
	"./Dessert/012-muffin.svg": 1367,
	"./Dessert/013-roll cake.svg": 1368,
	"./Dessert/014-apple pie.svg": 1369,
	"./Dessert/015-marshmallow.svg": 1370,
	"./Dessert/016-brownie.svg": 1371,
	"./Dessert/018-crepe.svg": 1372,
	"./Dessert/022-lollipop.svg": 1373,
	"./Dessert/023-donut.svg": 1374,
	"./Dessert/024-chocolate bar.svg": 1375,
	"./Dessert/027-macaron.svg": 1376,
	"./Dinosaur/001-parasaurolophus.svg": 1377,
	"./Dinosaur/002-ankylosaurus.svg": 1378,
	"./Dinosaur/005-corythosaurus.svg": 1379,
	"./Dinosaur/006-dinosaur.svg": 1380,
	"./Dinosaur/007-dilophosaurus.svg": 1381,
	"./Dinosaur/008-fossil.svg": 1382,
	"./Dinosaur/011-tyrannosaurus rex.svg": 1383,
	"./Dinosaur/012-pteranodon.svg": 1384,
	"./Dinosaur/013-mosasaurus.svg": 1385,
	"./Dinosaur/014-elasmosaurus.svg": 1386,
	"./Dinosaur/016-shark.svg": 1387,
	"./Dinosaur/018-primitive.svg": 1388,
	"./Dinosaur/022-triceratops.svg": 1389,
	"./Dinosaur/025-stegosaurus.svg": 1390,
	"./Dinosaur/027-archaeopteryx.svg": 1391,
	"./Dinosaur/028-brachiosaurus.svg": 1392,
	"./Diving/001-shark.svg": 1393,
	"./Diving/003-buoy.svg": 1394,
	"./Diving/004-action camera.svg": 1395,
	"./Diving/005-compass.svg": 1396,
	"./Diving/008-diver.svg": 1397,
	"./Diving/010-flippers.svg": 1398,
	"./Diving/011-goggles.svg": 1399,
	"./Diving/012-dive light.svg": 1400,
	"./Diving/014-boots.svg": 1401,
	"./Diving/015-gloves.svg": 1402,
	"./Diving/017-gun.svg": 1403,
	"./Diving/021-meter.svg": 1404,
	"./Diving/022-whistle.svg": 1405,
	"./Diving/023-oxygen.svg": 1406,
	"./Diving/027-lifejacket.svg": 1407,
	"./Diving/028-wetsuit.svg": 1408,
	"./Dogs/001-Australian Shepherd.svg": 1409,
	"./Dogs/002-Beagle.svg": 1410,
	"./Dogs/003-Boxer.svg": 1411,
	"./Dogs/004-Bulldog.svg": 1412,
	"./Dogs/006-Dachshund.svg": 1413,
	"./Dogs/007-Doberman.svg": 1414,
	"./Dogs/009-German Shepherd.svg": 1415,
	"./Dogs/010-Pointer.svg": 1416,
	"./Dogs/011-Golden Retriever.svg": 1417,
	"./Dogs/012-Great Dane.svg": 1418,
	"./Dogs/015-Corgi.svg": 1419,
	"./Dogs/016-Poodle.svg": 1420,
	"./Dogs/017-Rottweiler.svg": 1421,
	"./Dogs/018-Shih Tzu.svg": 1422,
	"./Dogs/019-Siberian Husky.svg": 1423,
	"./Dogs/020-Yorkshire Terrier.svg": 1424,
	"./Easter/001-angel.svg": 1425,
	"./Easter/004-bell.svg": 1426,
	"./Easter/008-bunny.svg": 1427,
	"./Easter/009-butterfly.svg": 1428,
	"./Easter/010-calendar.svg": 1429,
	"./Easter/012-candle.svg": 1430,
	"./Easter/013-candy.svg": 1431,
	"./Easter/014-carrot.svg": 1432,
	"./Easter/015-chick.svg": 1433,
	"./Easter/016-chicken.svg": 1434,
	"./Easter/017-egg.svg": 1435,
	"./Easter/020-painting.svg": 1436,
	"./Easter/021-greeting card.svg": 1437,
	"./Easter/022-muffin.svg": 1438,
	"./Easter/023-polka dot.svg": 1439,
	"./Easter/025-wavy.svg": 1440,
	"./Economy/002-analysis.svg": 1441,
	"./Economy/003-balance.svg": 1442,
	"./Economy/004-bank.svg": 1443,
	"./Economy/007-bitcoin.svg": 1444,
	"./Economy/008-business.svg": 1445,
	"./Economy/010-cheque.svg": 1446,
	"./Economy/014-credit card.svg": 1447,
	"./Economy/017-exchange.svg": 1448,
	"./Economy/019-global economy.svg": 1449,
	"./Economy/021-growth.svg": 1450,
	"./Economy/023-insurance.svg": 1451,
	"./Economy/027-losses.svg": 1452,
	"./Economy/031-mobile store.svg": 1453,
	"./Economy/032-money.svg": 1454,
	"./Economy/035-online payment.svg": 1455,
	"./Economy/040-report.svg": 1456,
	"./Education/001-anatomy.svg": 1457,
	"./Education/002-painting.svg": 1458,
	"./Education/004-biology.svg": 1459,
	"./Education/005-blackboard.svg": 1460,
	"./Education/009-diploma.svg": 1461,
	"./Education/012-geography.svg": 1462,
	"./Education/013-graduate.svg": 1463,
	"./Education/017-librarian.svg": 1464,
	"./Education/018-library.svg": 1465,
	"./Education/020-mathematics.svg": 1466,
	"./Education/021-reading.svg": 1467,
	"./Education/024-school bus.svg": 1468,
	"./Education/025-school.svg": 1469,
	"./Education/027-stationery.svg": 1470,
	"./Education/031-teacher.svg": 1471,
	"./Education/034-thinking.svg": 1472,
	"./Emotion/001-smile.svg": 1473,
	"./Emotion/002-sad.svg": 1474,
	"./Emotion/003-lol.svg": 1475,
	"./Emotion/004-angry.svg": 1476,
	"./Emotion/005-cool.svg": 1477,
	"./Emotion/007-cry.svg": 1478,
	"./Emotion/009-sleep.svg": 1479,
	"./Emotion/010-naughty.svg": 1480,
	"./Emotion/011-worry.svg": 1481,
	"./Emotion/012-shocked.svg": 1482,
	"./Emotion/013-puke.svg": 1483,
	"./Emotion/015-smirk.svg": 1484,
	"./Emotion/016-upset.svg": 1485,
	"./Emotion/017-annoyed.svg": 1486,
	"./Emotion/018-confused.svg": 1487,
	"./Emotion/019-shy.svg": 1488,
	"./England/001-cricket.svg": 1489,
	"./England/002-soccer.svg": 1490,
	"./England/003-bus.svg": 1491,
	"./England/004-telephone booth.svg": 1492,
	"./England/005-excalibur.svg": 1493,
	"./England/007-crown.svg": 1494,
	"./England/010-mailbox.svg": 1495,
	"./England/011-queen.svg": 1496,
	"./England/012-Tower bridge.svg": 1497,
	"./England/016-stonehenge.svg": 1498,
	"./England/019-tower of london.svg": 1499,
	"./England/020-big ben.svg": 1500,
	"./England/021-rainy.svg": 1501,
	"./England/024-knight.svg": 1502,
	"./England/025-detective.svg": 1503,
	"./England/026-royal guard.svg": 1504,
	"./Entertainment/001-disco ball.svg": 1505,
	"./Entertainment/002-music.svg": 1506,
	"./Entertainment/005-trumpet.svg": 1507,
	"./Entertainment/006-guitar.svg": 1508,
	"./Entertainment/008-band.svg": 1509,
	"./Entertainment/009-piano.svg": 1510,
	"./Entertainment/010-dj mixer.svg": 1511,
	"./Entertainment/016-theater.svg": 1512,
	"./Entertainment/018-video camera.svg": 1513,
	"./Entertainment/019-clapperboard.svg": 1514,
	"./Entertainment/021-circus.svg": 1515,
	"./Entertainment/025-claw machine.svg": 1516,
	"./Entertainment/027-bowling ball.svg": 1517,
	"./Entertainment/036-Card game.svg": 1518,
	"./Entertainment/037-roller coaster.svg": 1519,
	"./Entertainment/038-flying chairs.svg": 1520,
	"./Exercise/001-weightlifting.svg": 1521,
	"./Exercise/004-smartwatch.svg": 1522,
	"./Exercise/005-bicycle.svg": 1523,
	"./Exercise/007-gym machine.svg": 1524,
	"./Exercise/009-waist.svg": 1525,
	"./Exercise/010-heart rate.svg": 1526,
	"./Exercise/012-water bottle.svg": 1527,
	"./Exercise/014-jump rope.svg": 1528,
	"./Exercise/016-stopwatch.svg": 1529,
	"./Exercise/018-dumbbell.svg": 1530,
	"./Exercise/022-expander.svg": 1531,
	"./Exercise/025-sneaker.svg": 1532,
	"./Exercise/027-shower.svg": 1533,
	"./Exercise/033-exercise.svg": 1534,
	"./Exercise/034-punching bag.svg": 1535,
	"./Exercise/047-basketball.svg": 1536,
	"./FairyTale1/001-knight.svg": 1537,
	"./FairyTale1/002-wizard.svg": 1538,
	"./FairyTale1/003-dwarf.svg": 1539,
	"./FairyTale1/004-elf.svg": 1540,
	"./FairyTale1/007-giant.svg": 1541,
	"./FairyTale1/008-gnome.svg": 1542,
	"./FairyTale1/009-little red riding hood.svg": 1543,
	"./FairyTale1/011-queen.svg": 1544,
	"./FairyTale1/012-king.svg": 1545,
	"./FairyTale1/016-fairy.svg": 1546,
	"./FairyTale1/019-goblin.svg": 1547,
	"./FairyTale1/021-pig.svg": 1548,
	"./FairyTale1/022-tin man.svg": 1549,
	"./FairyTale1/023-scarecrow.svg": 1550,
	"./FairyTale1/028-cyclops.svg": 1551,
	"./FairyTale1/030-mermaid.svg": 1552,
	"./FairyTale2/013-princess.svg": 1553,
	"./FairyTale2/014-prince.svg": 1554,
	"./FairyTale2/015-frog prince.svg": 1555,
	"./FairyTale2/017-robin hood.svg": 1556,
	"./FairyTale2/018-pirate.svg": 1557,
	"./FairyTale2/024-cowardly lion.svg": 1558,
	"./FairyTale2/025-pinocchio.svg": 1559,
	"./FairyTale2/026-puss in boots.svg": 1560,
	"./FairyTale2/031-genie.svg": 1561,
	"./FairyTale2/033-unicorn.svg": 1562,
	"./FairyTale2/034-dragon.svg": 1563,
	"./FairyTale2/035-phoenix.svg": 1564,
	"./FairyTale2/040-magic mirror.svg": 1565,
	"./FairyTale2/043-magic lamp.svg": 1566,
	"./FairyTale2/044-crystal ball.svg": 1567,
	"./FairyTale2/050-fairytale.svg": 1568,
	"./Farm1/005-sickle.svg": 1569,
	"./Farm1/006-shovel.svg": 1570,
	"./Farm1/008-fertilizer.svg": 1571,
	"./Farm1/011-hand saw.svg": 1572,
	"./Farm1/012-lawnmower.svg": 1573,
	"./Farm1/013-spray.svg": 1574,
	"./Farm1/018-tractor.svg": 1575,
	"./Farm1/021-glove.svg": 1576,
	"./Farm1/034-wheelbarrow.svg": 1577,
	"./Farm1/035-box.svg": 1578,
	"./Farm1/036-watering can.svg": 1579,
	"./Farm1/038-clippers.svg": 1580,
	"./Farm1/039-boot.svg": 1581,
	"./Farm1/040-bucket.svg": 1582,
	"./Farm1/041-rake.svg": 1583,
	"./Farm1/047-hose.svg": 1584,
	"./Farm2/001-apple.svg": 1585,
	"./Farm2/003-corn.svg": 1586,
	"./Farm2/016-broccoli.svg": 1587,
	"./Farm2/020-carrots.svg": 1588,
	"./Farm2/023-wheat.svg": 1589,
	"./Farm2/024-duck.svg": 1590,
	"./Farm2/025-eggs.svg": 1591,
	"./Farm2/026-tomatoes.svg": 1592,
	"./Farm2/027-milk.svg": 1593,
	"./Farm2/030-eggplant.svg": 1594,
	"./Farm2/031-jam.svg": 1595,
	"./Farm2/032-cheese.svg": 1596,
	"./Farm2/033-pumpkin.svg": 1597,
	"./Farm2/042-grapes.svg": 1598,
	"./Farm2/043-tomato.svg": 1599,
	"./Farm2/050-onion.svg": 1600,
	"./Farm3/002-snail.svg": 1601,
	"./Farm3/004-flower.svg": 1602,
	"./Farm3/007-plant.svg": 1603,
	"./Farm3/014-windmill.svg": 1604,
	"./Farm3/015-chicken.svg": 1605,
	"./Farm3/017-cow.svg": 1606,
	"./Farm3/019-scarecrow.svg": 1607,
	"./Farm3/022-sunflower.svg": 1608,
	"./Farm3/028-leaf.svg": 1609,
	"./Farm3/029-fence.svg": 1610,
	"./Farm3/037-plant.svg": 1611,
	"./Farm3/044-tree.svg": 1612,
	"./Farm3/045-rain.svg": 1613,
	"./Farm3/046-farm.svg": 1614,
	"./Farm3/048-sun.svg": 1615,
	"./Farm3/049-plant.svg": 1616,
	"./Fastfood/002-tea.svg": 1617,
	"./Fastfood/008-french fries.svg": 1618,
	"./Fastfood/009-coffee.svg": 1619,
	"./Fastfood/010-burger.svg": 1620,
	"./Fastfood/011-ice cream.svg": 1621,
	"./Fastfood/012-cola.svg": 1622,
	"./Fastfood/013-milkshake.svg": 1623,
	"./Fastfood/014-ketchup & mustard.svg": 1624,
	"./Fastfood/015-hot dog.svg": 1625,
	"./Fastfood/017-croissant.svg": 1626,
	"./Fastfood/018-cheese.svg": 1627,
	"./Fastfood/021-fried chicken.svg": 1628,
	"./Fastfood/023-pizza slice.svg": 1629,
	"./Fastfood/027-donut.svg": 1630,
	"./Fastfood/035-taco.svg": 1631,
	"./Fastfood/041-waffles.svg": 1632,
	"./Finance/001-bear market.svg": 1633,
	"./Finance/011-currency exchange.svg": 1634,
	"./Finance/014-stock.svg": 1635,
	"./Finance/018-wealth.svg": 1636,
	"./Finance/022-bull market.svg": 1637,
	"./Finance/024-checkbook.svg": 1638,
	"./Finance/025-businessman.svg": 1639,
	"./Finance/031-saving.svg": 1640,
	"./Finance/034-cash.svg": 1641,
	"./Finance/035-tax.svg": 1642,
	"./Finance/037-strategy.svg": 1643,
	"./Finance/041-contract.svg": 1644,
	"./Finance/042-deposit.svg": 1645,
	"./Finance/045-auction.svg": 1646,
	"./Finance/046-diamond.svg": 1647,
	"./Finance/050-cash register.svg": 1648,
	"./Flags1/060-israel.svg": 1649,
	"./Flags1/066-germany.svg": 1650,
	"./Flags1/071-greece.svg": 1651,
	"./Flags1/072-denmark.svg": 1652,
	"./Flags1/073-sweden.svg": 1653,
	"./Flags1/077-france.svg": 1654,
	"./Flags1/097-switzerland.svg": 1655,
	"./Flags1/119-turkey.svg": 1656,
	"./Flags1/141-singapore.svg": 1657,
	"./Flags1/153-USA.svg": 1658,
	"./Flags1/184-thailand.svg": 1659,
	"./Flags1/206-canada.svg": 1660,
	"./Flags1/217-india.svg": 1661,
	"./Flags1/250-brazil.svg": 1662,
	"./Flags1/261-china.svg": 1663,
	"./Flags1/262-united kingdom.svg": 1664,
	"./Flags2/011-italy.svg": 1665,
	"./Flags2/022-european union.svg": 1666,
	"./Flags2/026-jamaica.svg": 1667,
	"./Flags2/033-japan.svg": 1668,
	"./Flags2/044-spain.svg": 1669,
	"./Flags2/048-new zealand.svg": 1670,
	"./Flags2/052-finland.svg": 1671,
	"./Flags2/054-belgium.svg": 1672,
	"./Flags2/055-south korea.svg": 1673,
	"./Flags2/058-norway.svg": 1674,
	"./Flags2/059-saudi arabia.svg": 1675,
	"./Flags2/064-argentina.svg": 1676,
	"./Flags2/075-south africa.svg": 1677,
	"./Flags2/078-indonesia.svg": 1678,
	"./Flags2/108-poland.svg": 1679,
	"./Flags2/228-russia.svg": 1680,
	"./Food1/003-ketchup.svg": 1681,
	"./Food1/004-cutlery.svg": 1682,
	"./Food1/010-chocolate bar.svg": 1683,
	"./Food1/011-instant coffee.svg": 1684,
	"./Food1/012-ice cream.svg": 1685,
	"./Food1/017-honey.svg": 1686,
	"./Food1/018-lemon slice.svg": 1687,
	"./Food1/019-lollipop.svg": 1688,
	"./Food1/020-mango.svg": 1689,
	"./Food1/025-popcorn.svg": 1690,
	"./Food1/028-fried egg.svg": 1691,
	"./Food1/033-honey jar.svg": 1692,
	"./Food1/034-grapes.svg": 1693,
	"./Food1/036-chicken legs.svg": 1694,
	"./Food1/037-cucumber.svg": 1695,
	"./Food1/042-apple.svg": 1696,
	"./Food2/005-nuggets.svg": 1697,
	"./Food2/006-pretzel.svg": 1698,
	"./Food2/008-salad.svg": 1699,
	"./Food2/013-croissant.svg": 1700,
	"./Food2/014-eggplant.svg": 1701,
	"./Food2/015-garlic.svg": 1702,
	"./Food2/016-grilled meat.svg": 1703,
	"./Food2/022-onion.svg": 1704,
	"./Food2/023-peach.svg": 1705,
	"./Food2/024-taco.svg": 1706,
	"./Food2/029-olive oil.svg": 1707,
	"./Food2/030-lollipop.svg": 1708,
	"./Food2/032-burger.svg": 1709,
	"./Food2/041-Butter.svg": 1710,
	"./Food2/043-water bottle.svg": 1711,
	"./Food2/044-chili pepper.svg": 1712,
	"./Food3/002-apple.svg": 1713,
	"./Food3/003-avocado.svg": 1714,
	"./Food3/004-bacon.svg": 1715,
	"./Food3/005-bananas.svg": 1716,
	"./Food3/006-bbq.svg": 1717,
	"./Food3/007-beer.svg": 1718,
	"./Food3/008-blueberries.svg": 1719,
	"./Food3/009-bread.svg": 1720,
	"./Food3/011-breakfast.svg": 1721,
	"./Food3/012-butter.svg": 1722,
	"./Food3/013-cake.svg": 1723,
	"./Food3/014-carrot.svg": 1724,
	"./Food3/019-roast chicken.svg": 1725,
	"./Food3/020-chocolate bar.svg": 1726,
	"./Food3/022-coffee.svg": 1727,
	"./Food3/023-corn.svg": 1728,
	"./Food4/033-eggs.svg": 1729,
	"./Food4/034-fast food.svg": 1730,
	"./Food4/035-fish.svg": 1731,
	"./Food4/036-flour.svg": 1732,
	"./Food4/041-grapes.svg": 1733,
	"./Food4/049-juice.svg": 1734,
	"./Food4/051-kiwi.svg": 1735,
	"./Food4/055-milk.svg": 1736,
	"./Food4/058-mushrooms.svg": 1737,
	"./Food4/061-olive oil.svg": 1738,
	"./Food4/069-pineapple.svg": 1739,
	"./Food4/070-pizza slice.svg": 1740,
	"./Food4/093-sushi.svg": 1741,
	"./Food4/094-taco.svg": 1742,
	"./Food4/096-tomato.svg": 1743,
	"./Food4/099-wine.svg": 1744,
	"./France/002-French flag.svg": 1745,
	"./France/003-Eiffel Tower.svg": 1746,
	"./France/004-baguette.svg": 1747,
	"./France/005-french.svg": 1748,
	"./France/006-cheese.svg": 1749,
	"./France/009-Arc De Triomphe.svg": 1750,
	"./France/010-poodle.svg": 1751,
	"./France/013-perfume.svg": 1752,
	"./France/014-fashion.svg": 1753,
	"./France/017-painting.svg": 1754,
	"./France/018-wine.svg": 1755,
	"./France/019-macaroon.svg": 1756,
	"./France/023-snails.svg": 1757,
	"./France/024-cock.svg": 1758,
	"./France/026-kepi.svg": 1759,
	"./France/030-croissant.svg": 1760,
	"./Fruit/004-pear.svg": 1761,
	"./Fruit/005-mangosteen.svg": 1762,
	"./Fruit/016-melon.svg": 1763,
	"./Fruit/024-strawberry.svg": 1764,
	"./Fruit/025-grapes.svg": 1765,
	"./Fruit/026-apple.svg": 1766,
	"./Fruit/032-cherry.svg": 1767,
	"./Fruit/033-raspberry.svg": 1768,
	"./Fruit/034-blueberries.svg": 1769,
	"./Fruit/040-papaya.svg": 1770,
	"./Fruit/041-banana.svg": 1771,
	"./Fruit/043-lemon.svg": 1772,
	"./Fruit/045-orange.svg": 1773,
	"./Fruit/046-peach.svg": 1774,
	"./Fruit/048-pineapple.svg": 1775,
	"./Fruit/049-watermelon.svg": 1776,
	"./Genres1/003-horror.svg": 1777,
	"./Genres1/004-romantic novel.svg": 1778,
	"./Genres1/005-Science fiction.svg": 1779,
	"./Genres1/007-psychology.svg": 1780,
	"./Genres1/008-science.svg": 1781,
	"./Genres1/009-biological.svg": 1782,
	"./Genres1/010-cookbook.svg": 1783,
	"./Genres1/011-adventure.svg": 1784,
	"./Genres1/012-crime.svg": 1785,
	"./Genres1/017-law book.svg": 1786,
	"./Genres1/018-sport.svg": 1787,
	"./Genres1/020-biography.svg": 1788,
	"./Genres1/025-comic.svg": 1789,
	"./Genres1/026-psychology.svg": 1790,
	"./Genres1/033-mystery.svg": 1791,
	"./Genres1/036-fantasy.svg": 1792,
	"./Genres2/001-wild animals.svg": 1793,
	"./Genres2/006-joke.svg": 1794,
	"./Genres2/013-botanic.svg": 1795,
	"./Genres2/014-art book.svg": 1796,
	"./Genres2/015-pharmacy.svg": 1797,
	"./Genres2/016-game.svg": 1798,
	"./Genres2/019-idea.svg": 1799,
	"./Genres2/021-millionaire.svg": 1800,
	"./Genres2/022-graphic design.svg": 1801,
	"./Genres2/023-politics.svg": 1802,
	"./Genres2/024-dictionary.svg": 1803,
	"./Genres2/027-house.svg": 1804,
	"./Genres2/028-garden.svg": 1805,
	"./Genres2/037-pets.svg": 1806,
	"./Genres2/039-history.svg": 1807,
	"./Genres2/040-war.svg": 1808,
	"./Geography/001-forest.svg": 1809,
	"./Geography/002-search.svg": 1810,
	"./Geography/014-satellite.svg": 1811,
	"./Geography/017-navigation.svg": 1812,
	"./Geography/021-signpost.svg": 1813,
	"./Geography/024-flag.svg": 1814,
	"./Geography/026-sea.svg": 1815,
	"./Geography/027-atmosphere.svg": 1816,
	"./Geography/029-telescope.svg": 1817,
	"./Geography/032-earth structure.svg": 1818,
	"./Geography/033-mountain.svg": 1819,
	"./Geography/035-volcano.svg": 1820,
	"./Geography/036-gps.svg": 1821,
	"./Geography/038-world map.svg": 1822,
	"./Geography/039-compass.svg": 1823,
	"./Geography/040-globe.svg": 1824,
	"./Geology/001-drilling rig.svg": 1825,
	"./Geology/003-construction.svg": 1826,
	"./Geology/004-measurement.svg": 1827,
	"./Geology/010-excavation.svg": 1828,
	"./Geology/013-fuel.svg": 1829,
	"./Geology/014-chemical analysis.svg": 1830,
	"./Geology/025-fossil.svg": 1831,
	"./Geology/026-tower.svg": 1832,
	"./Geology/027-analyzer.svg": 1833,
	"./Geology/029-analysis.svg": 1834,
	"./Geology/036-drone.svg": 1835,
	"./Geology/038-mine.svg": 1836,
	"./Geology/039-crystals.svg": 1837,
	"./Geology/043-implode.svg": 1838,
	"./Geology/044-drilling.svg": 1839,
	"./Geology/049-geological.svg": 1840,
	"./Germany/004-pub.svg": 1841,
	"./Germany/005-barrel.svg": 1842,
	"./Germany/006-beer.svg": 1843,
	"./Germany/007-berlin cathedral.svg": 1844,
	"./Germany/008-bottles.svg": 1845,
	"./Germany/012-castle.svg": 1846,
	"./Germany/013-cheese.svg": 1847,
	"./Germany/015-cuckoo clock.svg": 1848,
	"./Germany/019-german flag.svg": 1849,
	"./Germany/020-Holstentor.svg": 1850,
	"./Germany/021-house.svg": 1851,
	"./Germany/023-mountain.svg": 1852,
	"./Germany/025-powerplant.svg": 1853,
	"./Germany/026-sausage.svg": 1854,
	"./Germany/028-trumpet.svg": 1855,
	"./Germany/029-windmill.svg": 1856,
	"./Halloween/001-pumpkin.svg": 1857,
	"./Halloween/002-vampire.svg": 1858,
	"./Halloween/003-bat.svg": 1859,
	"./Halloween/004-zombie.svg": 1860,
	"./Halloween/005-haunted house.svg": 1861,
	"./Halloween/006-ghost.svg": 1862,
	"./Halloween/007-broom.svg": 1863,
	"./Halloween/008-coffin.svg": 1864,
	"./Halloween/009-spider.svg": 1865,
	"./Halloween/010-grave.svg": 1866,
	"./Halloween/013-black cat.svg": 1867,
	"./Halloween/014-candy.svg": 1868,
	"./Halloween/015-witch hat.svg": 1869,
	"./Halloween/016-skull.svg": 1870,
	"./Halloween/018-cobweb.svg": 1871,
	"./Halloween/019-poison.svg": 1872,
	"./HealthyLife1/001-aim.svg": 1873,
	"./HealthyLife1/002-check up.svg": 1874,
	"./HealthyLife1/003-bad habits.svg": 1875,
	"./HealthyLife1/004-check.svg": 1876,
	"./HealthyLife1/009-healthy diet.svg": 1877,
	"./HealthyLife1/010-excercise.svg": 1878,
	"./HealthyLife1/011-confidence.svg": 1879,
	"./HealthyLife1/012-sleep well.svg": 1880,
	"./HealthyLife1/017-tasks.svg": 1881,
	"./HealthyLife1/018-journey.svg": 1882,
	"./HealthyLife1/019-investment.svg": 1883,
	"./HealthyLife1/020-study.svg": 1884,
	"./HealthyLife1/025-positive thinking.svg": 1885,
	"./HealthyLife1/027-read.svg": 1886,
	"./HealthyLife1/028-saving money.svg": 1887,
	"./HealthyLife1/036-to do list.svg": 1888,
	"./HealthyLife2/005-working.svg": 1889,
	"./HealthyLife2/006-creative work.svg": 1890,
	"./HealthyLife2/007-drink water.svg": 1891,
	"./HealthyLife2/008-tea.svg": 1892,
	"./HealthyLife2/013-get up early.svg": 1893,
	"./HealthyLife2/014-breakfast.svg": 1894,
	"./HealthyLife2/016-hug.svg": 1895,
	"./HealthyLife2/021-relaxed.svg": 1896,
	"./HealthyLife2/022-meditate.svg": 1897,
	"./HealthyLife2/023-nature protection.svg": 1898,
	"./HealthyLife2/024-dental care.svg": 1899,
	"./HealthyLife2/029-handsome.svg": 1900,
	"./HealthyLife2/031-donate.svg": 1901,
	"./HealthyLife2/032-basketball.svg": 1902,
	"./HealthyLife2/033-family.svg": 1903,
	"./HealthyLife2/034-walking dog.svg": 1904,
	"./HeavyVehicles/003-bulldozer.svg": 1905,
	"./HeavyVehicles/004-road roller.svg": 1906,
	"./HeavyVehicles/005-dumper truck.svg": 1907,
	"./HeavyVehicles/006-cargo ship.svg": 1908,
	"./HeavyVehicles/007-cruiser.svg": 1909,
	"./HeavyVehicles/008-drilling machine.svg": 1910,
	"./HeavyVehicles/009-fishing boat.svg": 1911,
	"./HeavyVehicles/010-helicopter.svg": 1912,
	"./HeavyVehicles/016-locomotive.svg": 1913,
	"./HeavyVehicles/018-army airplane.svg": 1914,
	"./HeavyVehicles/026-rocket launcher.svg": 1915,
	"./HeavyVehicles/029-tank.svg": 1916,
	"./HeavyVehicles/032-tram.svg": 1917,
	"./HeavyVehicles/034-truck.svg": 1918,
	"./HeavyVehicles/038-warship.svg": 1919,
	"./HeavyVehicles/040-yacht.svg": 1920,
	"./Hobby1/001-chess.svg": 1921,
	"./Hobby1/002-confectioner.svg": 1922,
	"./Hobby1/003-video game controller.svg": 1923,
	"./Hobby1/004-fishing.svg": 1924,
	"./Hobby1/009-guitar.svg": 1925,
	"./Hobby1/010-beer.svg": 1926,
	"./Hobby1/011-cards.svg": 1927,
	"./Hobby1/012-popcorn.svg": 1928,
	"./Hobby1/017-roller skate.svg": 1929,
	"./Hobby1/018-basketball.svg": 1930,
	"./Hobby1/019-kite.svg": 1931,
	"./Hobby1/020-coffee.svg": 1932,
	"./Hobby1/025-ipod.svg": 1933,
	"./Hobby1/026-ping pong.svg": 1934,
	"./Hobby1/027-gym.svg": 1935,
	"./Hobby1/028-videogame.svg": 1936,
	"./Hobby2/005-photography.svg": 1937,
	"./Hobby2/006-knitting.svg": 1938,
	"./Hobby2/007-chef.svg": 1939,
	"./Hobby2/008-snorkeling.svg": 1940,
	"./Hobby2/013-bowling.svg": 1941,
	"./Hobby2/014-backpack.svg": 1942,
	"./Hobby2/015-travelling.svg": 1943,
	"./Hobby2/016-paint.svg": 1944,
	"./Hobby2/023-makeup.svg": 1945,
	"./Hobby2/024-rugby ball.svg": 1946,
	"./Hobby2/029-handmade.svg": 1947,
	"./Hobby2/030-ice cream.svg": 1948,
	"./Hobby2/031-caravan.svg": 1949,
	"./Hobby2/032-microphone.svg": 1950,
	"./Hobby2/049-kitchen utensils.svg": 1951,
	"./Hobby2/050-writing.svg": 1952,
	"./Hobby3/033-train.svg": 1953,
	"./Hobby3/034-tennis.svg": 1954,
	"./Hobby3/035-easel.svg": 1955,
	"./Hobby3/036-tv.svg": 1956,
	"./Hobby3/037-sculpting tools.svg": 1957,
	"./Hobby3/038-adjustable wrench.svg": 1958,
	"./Hobby3/039-planet.svg": 1959,
	"./Hobby3/040-magic hat.svg": 1960,
	"./Hobby3/041-paint brush.svg": 1961,
	"./Hobby3/042-shopping.svg": 1962,
	"./Hobby3/043-wine.svg": 1963,
	"./Hobby3/044-piano.svg": 1964,
	"./Hobby3/045-golf.svg": 1965,
	"./Hobby3/046-archery.svg": 1966,
	"./Hobby3/047-cocktail.svg": 1967,
	"./Hobby3/048-noodles.svg": 1968,
	"./Home1/001-air conditioner.svg": 1969,
	"./Home1/002-alarm clock.svg": 1970,
	"./Home1/003-backpack.svg": 1971,
	"./Home1/004-bathroom.svg": 1972,
	"./Home1/005-bed.svg": 1973,
	"./Home1/006-bike.svg": 1974,
	"./Home1/009-breakfast.svg": 1975,
	"./Home1/010-broom.svg": 1976,
	"./Home1/011-cap.svg": 1977,
	"./Home1/012-check list.svg": 1978,
	"./Home1/013-clock.svg": 1979,
	"./Home1/014-coffee.svg": 1980,
	"./Home1/019-glasses.svg": 1981,
	"./Home1/020-hair comb.svg": 1982,
	"./Home1/021-hand mirror.svg": 1983,
	"./Home1/022-headphones.svg": 1984,
	"./Home2/025-lamp desk.svg": 1985,
	"./Home2/026-lipstick.svg": 1986,
	"./Home2/027-mail.svg": 1987,
	"./Home2/028-mail box.svg": 1988,
	"./Home2/030-notebook.svg": 1989,
	"./Home2/033-razor.svg": 1990,
	"./Home2/035-shoes.svg": 1991,
	"./Home2/036-shopping bag.svg": 1992,
	"./Home2/037-socks.svg": 1993,
	"./Home2/038-soda.svg": 1994,
	"./Home2/039-telephone.svg": 1995,
	"./Home2/040-toaster.svg": 1996,
	"./Home2/041-toilet paper.svg": 1997,
	"./Home2/042-Tooth Brush.svg": 1998,
	"./Home2/045-umbrella.svg": 1999,
	"./Home2/049-wristwatch.svg": 2000,
	"./Home3/003-lamp.svg": 2001,
	"./Home3/012-stove.svg": 2002,
	"./Home3/013-coat-stand.svg": 2003,
	"./Home3/014-bookcase.svg": 2004,
	"./Home3/015-chimney.svg": 2005,
	"./Home3/020-blinds.svg": 2006,
	"./Home3/021-chair.svg": 2007,
	"./Home3/028-desk.svg": 2008,
	"./Home3/029-wardrobe.svg": 2009,
	"./Home3/030-chandelier.svg": 2010,
	"./Home3/032-dressing-table.svg": 2011,
	"./Home3/035-sink.svg": 2012,
	"./Home3/037-couch.svg": 2013,
	"./Home3/039-stairs.svg": 2014,
	"./Home3/042-dining-table.svg": 2015,
	"./Home3/047-bed.svg": 2016,
	"./Home4/001-painting-roller.svg": 2017,
	"./Home4/002-paint-bucket.svg": 2018,
	"./Home4/005-clock.svg": 2019,
	"./Home4/008-vacuum.svg": 2020,
	"./Home4/009-dishes.svg": 2021,
	"./Home4/010-lotion.svg": 2022,
	"./Home4/011-blender.svg": 2023,
	"./Home4/016-wall-clock.svg": 2024,
	"./Home4/017-toilet.svg": 2025,
	"./Home4/019-towel.svg": 2026,
	"./Home4/022-trash-can.svg": 2027,
	"./Home4/024-washer.svg": 2028,
	"./Home4/031-fishbowl.svg": 2029,
	"./Home4/033-fridge.svg": 2030,
	"./Home4/041-bathroom.svg": 2031,
	"./Home4/049-frame.svg": 2032,
	"./HumanBody/005-hand.svg": 2033,
	"./HumanBody/006-nose.svg": 2034,
	"./HumanBody/007-throat.svg": 2035,
	"./HumanBody/009-ear.svg": 2036,
	"./HumanBody/011-eye.svg": 2037,
	"./HumanBody/012-tooth.svg": 2038,
	"./HumanBody/020-finger.svg": 2039,
	"./HumanBody/021-neck.svg": 2040,
	"./HumanBody/023-buttocks.svg": 2041,
	"./HumanBody/027-arm.svg": 2042,
	"./HumanBody/031-foot.svg": 2043,
	"./HumanBody/032-hair.svg": 2044,
	"./HumanBody/035-male body.svg": 2045,
	"./HumanBody/039-knee.svg": 2046,
	"./HumanBody/046-feet.svg": 2047,
	"./HumanBody/049-back.svg": 2048,
	"./IcecreamShop/004-popsicle.svg": 2049,
	"./IcecreamShop/006-ice cream.svg": 2050,
	"./IcecreamShop/015-smoothie.svg": 2051,
	"./IcecreamShop/019-pancake.svg": 2052,
	"./IcecreamShop/020-ice cream sandwich.svg": 2053,
	"./IcecreamShop/025-cone.svg": 2054,
	"./IcecreamShop/026-shop.svg": 2055,
	"./IcecreamShop/027-kiosk.svg": 2056,
	"./IcecreamShop/028-food stand.svg": 2057,
	"./IcecreamShop/029-ice cream truck.svg": 2058,
	"./IcecreamShop/031-ice cream machine.svg": 2059,
	"./IcecreamShop/032-refrigerator.svg": 2060,
	"./IcecreamShop/033-menu.svg": 2061,
	"./IcecreamShop/041-scoop.svg": 2062,
	"./IcecreamShop/043-spoon.svg": 2063,
	"./IcecreamShop/049-wafer.svg": 2064,
	"./IndependenceDay/004-hat.svg": 2065,
	"./IndependenceDay/005-badge.svg": 2066,
	"./IndependenceDay/007-barbecue.svg": 2067,
	"./IndependenceDay/008-Soft drink.svg": 2068,
	"./IndependenceDay/009-sausage.svg": 2069,
	"./IndependenceDay/010-burger.svg": 2070,
	"./IndependenceDay/011-united states of america.svg": 2071,
	"./IndependenceDay/012-birthday cake.svg": 2072,
	"./IndependenceDay/017-statue of liberty.svg": 2073,
	"./IndependenceDay/021-drum.svg": 2074,
	"./IndependenceDay/022-fireworks.svg": 2075,
	"./IndependenceDay/023-balloons.svg": 2076,
	"./IndependenceDay/024-banners.svg": 2077,
	"./IndependenceDay/025-liberty bell.svg": 2078,
	"./IndependenceDay/027-cannon.svg": 2079,
	"./IndependenceDay/030-pistol.svg": 2080,
	"./India/002-mango.svg": 2081,
	"./India/003-namaste.svg": 2082,
	"./India/004-yoga.svg": 2083,
	"./India/005-cow.svg": 2084,
	"./India/006-Buddha.svg": 2085,
	"./India/007-spices.svg": 2086,
	"./India/008-henna.svg": 2087,
	"./India/009-Hinduism.svg": 2088,
	"./India/010-food.svg": 2089,
	"./India/011-Taj Mahal.svg": 2090,
	"./India/012-tiger.svg": 2091,
	"./India/013-peacock.svg": 2092,
	"./India/017-sari.svg": 2093,
	"./India/019-masala.svg": 2094,
	"./India/020-rickshaw.svg": 2095,
	"./India/021-ganesha.svg": 2096,
	"./Italy/002-cappuccino.svg": 2097,
	"./Italy/004-carnival.svg": 2098,
	"./Italy/006-cheese.svg": 2099,
	"./Italy/010-Colosseum.svg": 2100,
	"./Italy/013-flag.svg": 2101,
	"./Italy/015-gondola.svg": 2102,
	"./Italy/017-guitar.svg": 2103,
	"./Italy/018-harp.svg": 2104,
	"./Italy/021-Leaning Tower of Pisa.svg": 2105,
	"./Italy/028-olive oil.svg": 2106,
	"./Italy/032-pasta.svg": 2107,
	"./Italy/036-Pope.svg": 2108,
	"./Italy/042-tomato.svg": 2109,
	"./Italy/045-warrior.svg": 2110,
	"./Italy/046-wine.svg": 2111,
	"./Italy/049-bag.svg": 2112,
	"./Japan/004-ghost.svg": 2113,
	"./Japan/008-sumo.svg": 2114,
	"./Japan/009-dog.svg": 2115,
	"./Japan/016-ramen.svg": 2116,
	"./Japan/017-godzilla.svg": 2117,
	"./Japan/018-blowfish.svg": 2118,
	"./Japan/019-monkey.svg": 2119,
	"./Japan/025-teapot.svg": 2120,
	"./Japan/029-samurai.svg": 2121,
	"./Japan/032-koi.svg": 2122,
	"./Japan/033-rice.svg": 2123,
	"./Japan/034-katana.svg": 2124,
	"./Japan/043-octopus.svg": 2125,
	"./Japan/047-pagoda.svg": 2126,
	"./Japan/048-Mt Fuji.svg": 2127,
	"./Japan/049-sushi.svg": 2128,
	"./JapaneseFood/002-chef.svg": 2129,
	"./JapaneseFood/003-cherry blossom.svg": 2130,
	"./JapaneseFood/004-chopsticks.svg": 2131,
	"./JapaneseFood/005-crab.svg": 2132,
	"./JapaneseFood/006-curry rice.svg": 2133,
	"./JapaneseFood/008-egg rolls.svg": 2134,
	"./JapaneseFood/011-fried chicken.svg": 2135,
	"./JapaneseFood/013-green tea.svg": 2136,
	"./JapaneseFood/016-knife.svg": 2137,
	"./JapaneseFood/018-menu.svg": 2138,
	"./JapaneseFood/019-soup.svg": 2139,
	"./JapaneseFood/021-ramen.svg": 2140,
	"./JapaneseFood/027-octopus.svg": 2141,
	"./JapaneseFood/028-sushi.svg": 2142,
	"./JapaneseFood/029-tempura.svg": 2143,
	"./JapaneseFood/030-wasabi.svg": 2144,
	"./Jewelry/005-diamond ring.svg": 2145,
	"./Jewelry/007-bracelet.svg": 2146,
	"./Jewelry/015-pendant.svg": 2147,
	"./Jewelry/019-engagement rings.svg": 2148,
	"./Jewelry/020-studs.svg": 2149,
	"./Jewelry/021-earrings.svg": 2150,
	"./Jewelry/022-wristwatch.svg": 2151,
	"./Jewelry/023-pocket watch.svg": 2152,
	"./Jewelry/026-caliper.svg": 2153,
	"./Jewelry/028-certificate.svg": 2154,
	"./Jewelry/032-shopping bag.svg": 2155,
	"./Jewelry/037-magnifying glass.svg": 2156,
	"./Jewelry/038-present.svg": 2157,
	"./Jewelry/042-necklace.svg": 2158,
	"./Jewelry/043-jewelry box.svg": 2159,
	"./Jewelry/045-brooch.svg": 2160,
	"./Landmark1/001-eiffel tower.svg": 2161,
	"./Landmark1/002-pisa tower.svg": 2162,
	"./Landmark1/003-arch of triumph.svg": 2163,
	"./Landmark1/004-big ben.svg": 2164,
	"./Landmark1/009-sagrada familia.svg": 2165,
	"./Landmark1/010-london eye.svg": 2166,
	"./Landmark1/011-taj mahal.svg": 2167,
	"./Landmark1/012-tian tan buddha.svg": 2168,
	"./Landmark1/017-angkor wat.svg": 2169,
	"./Landmark1/018-borobudur.svg": 2170,
	"./Landmark1/019-statue of unity.svg": 2171,
	"./Landmark1/020-lotus temple.svg": 2172,
	"./Landmark1/025-independence.svg": 2173,
	"./Landmark1/026-obelisk of buenos aires.svg": 2174,
	"./Landmark1/027-moai.svg": 2175,
	"./Landmark1/028-golden gate bridge.svg": 2176,
	"./Landmark2/005-stonehenge.svg": 2177,
	"./Landmark2/006-Colosseum.svg": 2178,
	"./Landmark2/007-cathedral of saint basil.svg": 2179,
	"./Landmark2/008-parthenon.svg": 2180,
	"./Landmark2/013-great wall of china.svg": 2181,
	"./Landmark2/014-blue mosque.svg": 2182,
	"./Landmark2/015-azadi.svg": 2183,
	"./Landmark2/016-gate of all nations.svg": 2184,
	"./Landmark2/021-forbidden city.svg": 2185,
	"./Landmark2/022-statue of liberty.svg": 2186,
	"./Landmark2/023-cathedral of brasilia.svg": 2187,
	"./Landmark2/024-Chichen Itza.svg": 2188,
	"./Landmark2/029-cn tower.svg": 2189,
	"./Landmark2/030-sanctuary of our lady of lourdes.svg": 2190,
	"./Landmark2/031-pyramids.svg": 2191,
	"./Landmark2/032-abu simbel.svg": 2192,
	"./Landmark3/033-african renaissance monument.svg": 2193,
	"./Landmark3/034-black star.svg": 2194,
	"./Landmark3/035-monument of the martyr.svg": 2195,
	"./Landmark3/036-djinguereber mosque.svg": 2196,
	"./Landmark3/037-sydney opera house.svg": 2197,
	"./Landmark3/038-burj khalifa.svg": 2198,
	"./Landmark3/039-gateway arch.svg": 2199,
	"./Landmark3/040-shwedagon pagoda.svg": 2200,
	"./Landmark3/041-itsukushima shrine.svg": 2201,
	"./Landmark3/042-oriental pearl tower.svg": 2202,
	"./Landmark3/043-turning torso.svg": 2203,
	"./Landmark3/044-the gherkin.svg": 2204,
	"./Landmark3/045-king ezanas stela.svg": 2205,
	"./Landmark3/046-Al shaheed.svg": 2206,
	"./Landmark3/047-great mosque of samarra.svg": 2207,
	"./Landmark3/048-louvre.svg": 2208,
	"./Landscape1/001-mountain.svg": 2209,
	"./Landscape1/004-pier.svg": 2210,
	"./Landscape1/005-beach.svg": 2211,
	"./Landscape1/008-glacier.svg": 2212,
	"./Landscape1/009-iceberg.svg": 2213,
	"./Landscape1/013-grassland.svg": 2214,
	"./Landscape1/016-volcano.svg": 2215,
	"./Landscape1/018-desert.svg": 2216,
	"./Landscape1/020-canyon.svg": 2217,
	"./Landscape1/024-river.svg": 2218,
	"./Landscape1/025-terrace.svg": 2219,
	"./Landscape1/031-hill.svg": 2220,
	"./Landscape1/034-aurora borealis.svg": 2221,
	"./Landscape1/036-cliff.svg": 2222,
	"./Landscape1/045-waterfall.svg": 2223,
	"./Landscape1/048-island.svg": 2224,
	"./Landscape2/011-rainbow.svg": 2225,
	"./Landscape2/012-igloo.svg": 2226,
	"./Landscape2/017-cave.svg": 2227,
	"./Landscape2/022-sunset.svg": 2228,
	"./Landscape2/023-savannah.svg": 2229,
	"./Landscape2/026-mountain.svg": 2230,
	"./Landscape2/027-rainforest.svg": 2231,
	"./Landscape2/028-meadow.svg": 2232,
	"./Landscape2/030-lake.svg": 2233,
	"./Landscape2/032-road.svg": 2234,
	"./Landscape2/033-sunrise.svg": 2235,
	"./Landscape2/035-forest.svg": 2236,
	"./Landscape2/039-city.svg": 2237,
	"./Landscape2/042-bridge.svg": 2238,
	"./Landscape2/043-dam.svg": 2239,
	"./Landscape2/049-lighthouse.svg": 2240,
	"./Math1/051-division.svg": 2241,
	"./Math1/051-equal.svg": 2242,
	"./Math1/051-function.svg": 2243,
	"./Math1/051-infinity.svg": 2244,
	"./Math1/051-is approximately equal to.svg": 2245,
	"./Math1/051-is greater than or equal to.svg": 2246,
	"./Math1/051-is greater than.svg": 2247,
	"./Math1/051-is less than or equal to.svg": 2248,
	"./Math1/051-is less than.svg": 2249,
	"./Math1/051-minus.svg": 2250,
	"./Math1/051-multiply.svg": 2251,
	"./Math1/051-percentage.svg": 2252,
	"./Math1/051-pi.svg": 2253,
	"./Math1/051-plus.svg": 2254,
	"./Math1/051-square root.svg": 2255,
	"./Math1/051-the sum of.svg": 2256,
	"./Math2/051-abacus.svg": 2257,
	"./Math2/051-angle.svg": 2258,
	"./Math2/051-axis.svg": 2259,
	"./Math2/051-compass.svg": 2260,
	"./Math2/051-cone.svg": 2261,
	"./Math2/051-cube.svg": 2262,
	"./Math2/051-cylinder.svg": 2263,
	"./Math2/051-equation.svg": 2264,
	"./Math2/051-parabolic.svg": 2265,
	"./Math2/051-pie graph.svg": 2266,
	"./Math2/051-protractor.svg": 2267,
	"./Math2/051-pyramid.svg": 2268,
	"./Math2/051-route.svg": 2269,
	"./Math2/051-set-square.svg": 2270,
	"./Math2/051-sphere.svg": 2271,
	"./Math2/051-triangle.svg": 2272,
	"./MedicalScience/003-stretcher.svg": 2273,
	"./MedicalScience/006-spine.svg": 2274,
	"./MedicalScience/009-dna.svg": 2275,
	"./MedicalScience/020-stethoscope.svg": 2276,
	"./MedicalScience/023-syringe.svg": 2277,
	"./MedicalScience/024-medicine.svg": 2278,
	"./MedicalScience/027-saline.svg": 2279,
	"./MedicalScience/028-fracture.svg": 2280,
	"./MedicalScience/029-x ray.svg": 2281,
	"./MedicalScience/037-temperature reader.svg": 2282,
	"./MedicalScience/040-microscope.svg": 2283,
	"./MedicalScience/041-CT scan.svg": 2284,
	"./MedicalScience/043-heart monitoring.svg": 2285,
	"./MedicalScience/047-wheelchair.svg": 2286,
	"./MedicalScience/048-examining table.svg": 2287,
	"./MedicalScience/050-ultrasound.svg": 2288,
	"./Medieval/001-axe.svg": 2289,
	"./Medieval/002-carriage.svg": 2290,
	"./Medieval/003-castle.svg": 2291,
	"./Medieval/004-catapult.svg": 2292,
	"./Medieval/006-crossbow.svg": 2293,
	"./Medieval/007-crown.svg": 2294,
	"./Medieval/008-knight.svg": 2295,
	"./Medieval/009-dragon.svg": 2296,
	"./Medieval/011-fortress.svg": 2297,
	"./Medieval/017-horse.svg": 2298,
	"./Medieval/019-king.svg": 2299,
	"./Medieval/020-mace.svg": 2300,
	"./Medieval/026-spear.svg": 2301,
	"./Medieval/027-throne.svg": 2302,
	"./Medieval/028-trumpet.svg": 2303,
	"./Medieval/029-wizard.svg": 2304,
	"./MothersDay/002-mother.svg": 2305,
	"./MothersDay/003-grandma.svg": 2306,
	"./MothersDay/005-cake.svg": 2307,
	"./MothersDay/006-handbag.svg": 2308,
	"./MothersDay/007-pregnancy.svg": 2309,
	"./MothersDay/008-gift.svg": 2310,
	"./MothersDay/009-mug.svg": 2311,
	"./MothersDay/013-earring.svg": 2312,
	"./MothersDay/019-baby stroller.svg": 2313,
	"./MothersDay/023-necklace.svg": 2314,
	"./MothersDay/025-perfume.svg": 2315,
	"./MothersDay/027-baby.svg": 2316,
	"./MothersDay/044-drawing.svg": 2317,
	"./MothersDay/046-flower.svg": 2318,
	"./MothersDay/047-chocolate box.svg": 2319,
	"./MothersDay/049-greeting card.svg": 2320,
	"./Museum/001-museum ticket.svg": 2321,
	"./Museum/002-african mask.svg": 2322,
	"./Museum/004-vase.svg": 2323,
	"./Museum/010-audio guide.svg": 2324,
	"./Museum/014-bust.svg": 2325,
	"./Museum/018-classic art.svg": 2326,
	"./Museum/026-dinosaur.svg": 2327,
	"./Museum/034-fossil.svg": 2328,
	"./Museum/048-metal detector.svg": 2329,
	"./Museum/050-modern art.svg": 2330,
	"./Museum/052-mummy.svg": 2331,
	"./Museum/062-no flash.svg": 2332,
	"./Museum/068-painting.svg": 2333,
	"./Museum/072-prehistoric.svg": 2334,
	"./Museum/078-statue.svg": 2335,
	"./Museum/079-ticket office.svg": 2336,
	"./MusicInstruments/001-tuba.svg": 2337,
	"./MusicInstruments/002-harmonica.svg": 2338,
	"./MusicInstruments/003-keyboard.svg": 2339,
	"./MusicInstruments/004-trumpet.svg": 2340,
	"./MusicInstruments/005-violin.svg": 2341,
	"./MusicInstruments/011-harp.svg": 2342,
	"./MusicInstruments/012-drums.svg": 2343,
	"./MusicInstruments/016-kettledrum.svg": 2344,
	"./MusicInstruments/019-xylophone.svg": 2345,
	"./MusicInstruments/020-cymbals.svg": 2346,
	"./MusicInstruments/022-guitar.svg": 2347,
	"./MusicInstruments/026-maracas.svg": 2348,
	"./MusicInstruments/027-accordion.svg": 2349,
	"./MusicInstruments/029-triangle.svg": 2350,
	"./MusicInstruments/030-tambourine.svg": 2351,
	"./MusicInstruments/09-piano.svg": 2352,
	"./NASA/003-astronaut.svg": 2353,
	"./NASA/008-lunar roving vehicle.svg": 2354,
	"./NASA/010-space capsule.svg": 2355,
	"./NASA/012-observatory.svg": 2356,
	"./NASA/015-rocket launch.svg": 2357,
	"./NASA/016-satellite dish.svg": 2358,
	"./NASA/018-satellite.svg": 2359,
	"./NASA/021-space shuttle.svg": 2360,
	"./NASA/023-space exploration.svg": 2361,
	"./NASA/024-inflatable space habitat.svg": 2362,
	"./NASA/026-rocket.svg": 2363,
	"./NASA/027-space station.svg": 2364,
	"./NASA/029-spacecraft.svg": 2365,
	"./NASA/031-spacecraft.svg": 2366,
	"./NASA/032-rover.svg": 2367,
	"./NASA/034-spaceship.svg": 2368,
	"./NaturalDisasters/001-earthquake.svg": 2369,
	"./NaturalDisasters/003-tornado.svg": 2370,
	"./NaturalDisasters/004-forest-fire.svg": 2371,
	"./NaturalDisasters/005-fire.svg": 2372,
	"./NaturalDisasters/006-storm.svg": 2373,
	"./NaturalDisasters/007-flood.svg": 2374,
	"./NaturalDisasters/009-tsunami.svg": 2375,
	"./NaturalDisasters/010-drought.svg": 2376,
	"./NaturalDisasters/011-wind.svg": 2377,
	"./NaturalDisasters/012-volcano.svg": 2378,
	"./NaturalDisasters/013-avalanche.svg": 2379,
	"./NaturalDisasters/014-landslide.svg": 2380,
	"./NaturalDisasters/016-dust-storm.svg": 2381,
	"./NaturalDisasters/017-hail.svg": 2382,
	"./NaturalDisasters/019-comet.svg": 2383,
	"./NaturalDisasters/020-snow.svg": 2384,
	"./NewYear/002-roast chicken.svg": 2385,
	"./NewYear/003-ham.svg": 2386,
	"./NewYear/005-cake.svg": 2387,
	"./NewYear/006-champagne.svg": 2388,
	"./NewYear/008-beer.svg": 2389,
	"./NewYear/010-toast.svg": 2390,
	"./NewYear/014-candles.svg": 2391,
	"./NewYear/016-balloons.svg": 2392,
	"./NewYear/021-party hat.svg": 2393,
	"./NewYear/024-wreath.svg": 2394,
	"./NewYear/025-party blower.svg": 2395,
	"./NewYear/026-party popper.svg": 2396,
	"./NewYear/028-fireworks.svg": 2397,
	"./NewYear/030-spotlight.svg": 2398,
	"./NewYear/047-countdown.svg": 2399,
	"./NewYear/048-bell.svg": 2400,
	"./NewYearResolution/01-no junk food.svg": 2401,
	"./NewYearResolution/02-stop smoking.svg": 2402,
	"./NewYearResolution/03-travel by car.svg": 2403,
	"./NewYearResolution/05-get engaged.svg": 2404,
	"./NewYearResolution/06-buy a house.svg": 2405,
	"./NewYearResolution/08-buy a new dress.svg": 2406,
	"./NewYearResolution/08-make more money.svg": 2407,
	"./NewYearResolution/11-control weight.svg": 2408,
	"./NewYearResolution/12-get married.svg": 2409,
	"./NewYearResolution/12-have good luck.svg": 2410,
	"./NewYearResolution/14-have a baby.svg": 2411,
	"./NewYearResolution/18-date with someone.svg": 2412,
	"./NewYearResolution/18-keep fit.svg": 2413,
	"./NewYearResolution/20-travel by cruise.svg": 2414,
	"./NewYearResolution/21-get promoted.svg": 2415,
	"./NewYearResolution/24-win a game.svg": 2416,
	"./Nuclear/003-atom.svg": 2417,
	"./Nuclear/004-battery.svg": 2418,
	"./Nuclear/005-radiation.svg": 2419,
	"./Nuclear/007-electricity.svg": 2420,
	"./Nuclear/008-engineer.svg": 2421,
	"./Nuclear/011-geiger counter.svg": 2422,
	"./Nuclear/013-gas mask.svg": 2423,
	"./Nuclear/014-missile.svg": 2424,
	"./Nuclear/017-nuclear bomb.svg": 2425,
	"./Nuclear/021-nuclear plant.svg": 2426,
	"./Nuclear/023-radioactive.svg": 2427,
	"./Nuclear/024-laboratory.svg": 2428,
	"./Nuclear/025-scientist.svg": 2429,
	"./Nuclear/027-protective wear.svg": 2430,
	"./Nuclear/028-nuclear energy.svg": 2431,
	"./Nuclear/030-toxic.svg": 2432,
	"./OlympicGames1/001-fencing.svg": 2433,
	"./OlympicGames1/002-golf.svg": 2434,
	"./OlympicGames1/003-ice hockey.svg": 2435,
	"./OlympicGames1/004-judo.svg": 2436,
	"./OlympicGames1/005-rowing.svg": 2437,
	"./OlympicGames1/006-american football.svg": 2438,
	"./OlympicGames1/007-sailing.svg": 2439,
	"./OlympicGames1/008-shooting.svg": 2440,
	"./OlympicGames1/009-table tennis.svg": 2441,
	"./OlympicGames1/010-tennis.svg": 2442,
	"./OlympicGames1/011-archery.svg": 2443,
	"./OlympicGames1/014-waterpolo.svg": 2444,
	"./OlympicGames1/015-weightlifting.svg": 2445,
	"./OlympicGames1/017-badminton.svg": 2446,
	"./OlympicGames1/018-swimming.svg": 2447,
	"./OlympicGames1/019-rhythmic gymnastics.svg": 2448,
	"./OlympicGames2/012-gymnastics.svg": 2449,
	"./OlympicGames2/013-volleyball.svg": 2450,
	"./OlympicGames2/020-synchronised swimming.svg": 2451,
	"./OlympicGames2/021-diving.svg": 2452,
	"./OlympicGames2/022-basketball.svg": 2453,
	"./OlympicGames2/023-equestrian.svg": 2454,
	"./OlympicGames2/026-bronze medal.svg": 2455,
	"./OlympicGames2/027-silver medal.svg": 2456,
	"./OlympicGames2/028-gold medal.svg": 2457,
	"./OlympicGames2/032-stadium.svg": 2458,
	"./OlympicGames2/033-beach volleyball.svg": 2459,
	"./OlympicGames2/043-boxing.svg": 2460,
	"./OlympicGames2/045-football.svg": 2461,
	"./OlympicGames2/046-canoe.svg": 2462,
	"./OlympicGames2/047-cycling.svg": 2463,
	"./OlympicGames2/049-bike.svg": 2464,
	"./Outdoor/001-snowboard.svg": 2465,
	"./Outdoor/002-skateboard.svg": 2466,
	"./Outdoor/003-kayak.svg": 2467,
	"./Outdoor/004-football.svg": 2468,
	"./Outdoor/006-hot air balloon.svg": 2469,
	"./Outdoor/014-tennis.svg": 2470,
	"./Outdoor/016-skateboard.svg": 2471,
	"./Outdoor/017-volleyball.svg": 2472,
	"./Outdoor/019-camping.svg": 2473,
	"./Outdoor/022-fishing.svg": 2474,
	"./Outdoor/023-surfing.svg": 2475,
	"./Outdoor/027-skates.svg": 2476,
	"./Outdoor/030-diving.svg": 2477,
	"./Outdoor/045-beach.svg": 2478,
	"./Outdoor/047-kick scooter.svg": 2479,
	"./Outdoor/050-basketball.svg": 2480,
	"./Physics/001-gravity.svg": 2481,
	"./Physics/003-formula.svg": 2482,
	"./Physics/004-pendulum.svg": 2483,
	"./Physics/008-radiation.svg": 2484,
	"./Physics/010-molecule.svg": 2485,
	"./Physics/011-atom.svg": 2486,
	"./Physics/012-waves.svg": 2487,
	"./Physics/016-positive ion.svg": 2488,
	"./Physics/017-lamp.svg": 2489,
	"./Physics/018-magnetic field.svg": 2490,
	"./Physics/019-electrical circuit.svg": 2491,
	"./Physics/022-prism.svg": 2492,
	"./Physics/023-magnet.svg": 2493,
	"./Physics/026-hypotenuse.svg": 2494,
	"./Physics/028-motion.svg": 2495,
	"./Physics/050-pulley.svg": 2496,
	"./Portugal/001-Aveiro Lighthouse.svg": 2497,
	"./Portugal/002-guitar.svg": 2498,
	"./Portugal/004-barrel.svg": 2499,
	"./Portugal/007-cheese.svg": 2500,
	"./Portugal/011-lavender.svg": 2501,
	"./Portugal/012-leito da bairrada.svg": 2502,
	"./Portugal/016-portugal cross.svg": 2503,
	"./Portugal/017-flag.svg": 2504,
	"./Portugal/018-woman.svg": 2505,
	"./Portugal/020-sailboat.svg": 2506,
	"./Portugal/021-sardines.svg": 2507,
	"./Portugal/022-canned sardine.svg": 2508,
	"./Portugal/023-soccer.svg": 2509,
	"./Portugal/028-tramway.svg": 2510,
	"./Portugal/029-windmill.svg": 2511,
	"./Portugal/030-wine.svg": 2512,
	"./PostOffice/001-delivery-truck.svg": 2513,
	"./PostOffice/002-postbox.svg": 2514,
	"./PostOffice/003-mailbox.svg": 2515,
	"./PostOffice/008-letters.svg": 2516,
	"./PostOffice/012-signature.svg": 2517,
	"./PostOffice/016-scales.svg": 2518,
	"./PostOffice/017-stamp.svg": 2519,
	"./PostOffice/020-express.svg": 2520,
	"./PostOffice/021-barcode.svg": 2521,
	"./PostOffice/022-cargo-ship.svg": 2522,
	"./PostOffice/024-package.svg": 2523,
	"./PostOffice/032-scooter.svg": 2524,
	"./PostOffice/033-forklift.svg": 2525,
	"./PostOffice/034-plane.svg": 2526,
	"./PostOffice/036-up.svg": 2527,
	"./PostOffice/037-fragile.svg": 2528,
	"./Profession1/001-accountant.svg": 2529,
	"./Profession1/002-architect.svg": 2530,
	"./Profession1/003-artist.svg": 2531,
	"./Profession1/004-astronaut.svg": 2532,
	"./Profession1/009-cashier.svg": 2533,
	"./Profession1/010-chef.svg": 2534,
	"./Profession1/011-scientist.svg": 2535,
	"./Profession1/012-delivery man.svg": 2536,
	"./Profession1/017-electrician.svg": 2537,
	"./Profession1/018-engineer.svg": 2538,
	"./Profession1/020-farmer.svg": 2539,
	"./Profession1/025-graphic designer.svg": 2540,
	"./Profession1/026-guard.svg": 2541,
	"./Profession1/027-hairstylist.svg": 2542,
	"./Profession1/028-lawyer.svg": 2543,
	"./Profession1/050-writer.svg": 2544,
	"./Profession2/005-banker.svg": 2545,
	"./Profession2/006-barista.svg": 2546,
	"./Profession2/007-bartender.svg": 2547,
	"./Profession2/008-bellboy.svg": 2548,
	"./Profession2/013-dentist.svg": 2549,
	"./Profession2/014-detective.svg": 2550,
	"./Profession2/015-doctor.svg": 2551,
	"./Profession2/016-doctor.svg": 2552,
	"./Profession2/021-fireman.svg": 2553,
	"./Profession2/022-fisherman.svg": 2554,
	"./Profession2/023-gamer.svg": 2555,
	"./Profession2/024-gardener.svg": 2556,
	"./Profession2/029-librarian.svg": 2557,
	"./Profession2/030-mechanic.svg": 2558,
	"./Profession2/031-mechanic.svg": 2559,
	"./Profession2/032-news anchor.svg": 2560,
	"./Profession3/033-farmer.svg": 2561,
	"./Profession3/034-painter.svg": 2562,
	"./Profession3/035-photographer.svg": 2563,
	"./Profession3/036-policeman.svg": 2564,
	"./Profession3/037-postman.svg": 2565,
	"./Profession3/038-priest.svg": 2566,
	"./Profession3/039-programmer.svg": 2567,
	"./Profession3/040-sailor.svg": 2568,
	"./Profession3/041-security man.svg": 2569,
	"./Profession3/042-taxi driver.svg": 2570,
	"./Profession3/043-technician.svg": 2571,
	"./Profession3/044-tourist.svg": 2572,
	"./Profession3/045-trainer.svg": 2573,
	"./Profession3/046-veterinarian.svg": 2574,
	"./Profession3/047-waiter.svg": 2575,
	"./Profession3/049-worker.svg": 2576,
	"./Ramadan/002-window.svg": 2577,
	"./Ramadan/004-carpet.svg": 2578,
	"./Ramadan/005-close eyes.svg": 2579,
	"./Ramadan/009-fasting.svg": 2580,
	"./Ramadan/012-halal.svg": 2581,
	"./Ramadan/013-kaaba.svg": 2582,
	"./Ramadan/016-moon.svg": 2583,
	"./Ramadan/017-mosque.svg": 2584,
	"./Ramadan/019-muslim.svg": 2585,
	"./Ramadan/020-no drinks.svg": 2586,
	"./Ramadan/021-no music.svg": 2587,
	"./Ramadan/023-no pork.svg": 2588,
	"./Ramadan/024-pray.svg": 2589,
	"./Ramadan/025-praying.svg": 2590,
	"./Ramadan/026-Quran.svg": 2591,
	"./Ramadan/030-sun.svg": 2592,
	"./RealEstate/004-blueprint.svg": 2593,
	"./RealEstate/005-condominium.svg": 2594,
	"./RealEstate/007-apartment.svg": 2595,
	"./RealEstate/013-warehouse.svg": 2596,
	"./RealEstate/022-auction.svg": 2597,
	"./RealEstate/029-cheque.svg": 2598,
	"./RealEstate/030-key.svg": 2599,
	"./RealEstate/031-cctv.svg": 2600,
	"./RealEstate/034-certificate.svg": 2601,
	"./RealEstate/036-fence.svg": 2602,
	"./RealEstate/037-window.svg": 2603,
	"./RealEstate/039-door.svg": 2604,
	"./RealEstate/040-mailbox.svg": 2605,
	"./RealEstate/048-fountain.svg": 2606,
	"./RealEstate/049-swimming pool.svg": 2607,
	"./RealEstate/050-shopping mall.svg": 2608,
	"./Russia/001-matryoshka doll.svg": 2609,
	"./Russia/003-Russia flag.svg": 2610,
	"./Russia/005-pine trees.svg": 2611,
	"./Russia/006-grizzly bear.svg": 2612,
	"./Russia/007-ballet dancer.svg": 2613,
	"./Russia/009-vodka.svg": 2614,
	"./Russia/010-Russian hat.svg": 2615,
	"./Russia/013-valenki.svg": 2616,
	"./Russia/014-caviar.svg": 2617,
	"./Russia/016-bread.svg": 2618,
	"./Russia/018-Cathedral of St Basil.svg": 2619,
	"./Russia/020-pancake.svg": 2620,
	"./Russia/028-pumpjack.svg": 2621,
	"./Russia/030-crown.svg": 2622,
	"./Russia/038-kvass.svg": 2623,
	"./Russia/047-rocket.svg": 2624,
	"./Sea1/001-albatross.svg": 2625,
	"./Sea1/002-anchor.svg": 2626,
	"./Sea1/003-coral.svg": 2627,
	"./Sea1/004-dolphin.svg": 2628,
	"./Sea1/009-jellyfish.svg": 2629,
	"./Sea1/010-ring buoy.svg": 2630,
	"./Sea1/011-lighthouse.svg": 2631,
	"./Sea1/012-marlin.svg": 2632,
	"./Sea1/017-turtle.svg": 2633,
	"./Sea1/018-seahorse.svg": 2634,
	"./Sea1/019-seal.svg": 2635,
	"./Sea1/020-seaweed.svg": 2636,
	"./Sea1/025-Shrimp.svg": 2637,
	"./Sea1/026-shell.svg": 2638,
	"./Sea1/027-starfish.svg": 2639,
	"./Sea1/028-stingray.svg": 2640,
	"./Sea2/005-fish.svg": 2641,
	"./Sea2/006-squid.svg": 2642,
	"./Sea2/007-hammerhead shark.svg": 2643,
	"./Sea2/008-jellyfish.svg": 2644,
	"./Sea2/014-octopus.svg": 2645,
	"./Sea2/015-pelican.svg": 2646,
	"./Sea2/016-sailor.svg": 2647,
	"./Sea2/021-shark.svg": 2648,
	"./Sea2/022-shell.svg": 2649,
	"./Sea2/023-ship wheel.svg": 2650,
	"./Sea2/024-sailboat.svg": 2651,
	"./Sea2/029-swallow.svg": 2652,
	"./Sea2/030-shark.svg": 2653,
	"./Sea2/031-walrus.svg": 2654,
	"./Sea2/032-shark.svg": 2655,
	"./Sea2/034-whale.svg": 2656,
	"./Sea3/010-orca.svg": 2657,
	"./Sea3/011-tuna.svg": 2658,
	"./Sea3/013-manta ray.svg": 2659,
	"./Sea3/014-mussel.svg": 2660,
	"./Sea3/016-sunfish.svg": 2661,
	"./Sea3/021-sea cow.svg": 2662,
	"./Sea3/024-narwhal.svg": 2663,
	"./Sea3/027-sea urchin.svg": 2664,
	"./Sea3/028-angelfish.svg": 2665,
	"./Sea3/029-angelfish.svg": 2666,
	"./Sea3/030-eel.svg": 2667,
	"./Sea3/032-puffer fish.svg": 2668,
	"./Sea3/033-flounder.svg": 2669,
	"./Sea3/035-swordfish.svg": 2670,
	"./Sea3/036-conch shell.svg": 2671,
	"./Sea3/043-surgeon fish.svg": 2672,
	"./Seafood/004-crab.svg": 2673,
	"./Seafood/008-jellyfish.svg": 2674,
	"./Seafood/010-lobster.svg": 2675,
	"./Seafood/011-mackerel.svg": 2676,
	"./Seafood/012-mussel.svg": 2677,
	"./Seafood/013-oyster.svg": 2678,
	"./Seafood/015-puffer fish.svg": 2679,
	"./Seafood/017-salmon.svg": 2680,
	"./Seafood/018-sardine.svg": 2681,
	"./Seafood/019-sashimi.svg": 2682,
	"./Seafood/020-sauce.svg": 2683,
	"./Seafood/021-sea urchin.svg": 2684,
	"./Seafood/022-seaweed.svg": 2685,
	"./Seafood/024-shrimp.svg": 2686,
	"./Seafood/025-squid.svg": 2687,
	"./Seafood/026-steamed fish.svg": 2688,
	"./Seasons/002-flower.svg": 2689,
	"./Seasons/006-wind.svg": 2690,
	"./Seasons/009-scuba diving.svg": 2691,
	"./Seasons/011-season.svg": 2692,
	"./Seasons/019-snowman.svg": 2693,
	"./Seasons/021-winter clothing.svg": 2694,
	"./Seasons/022-hot.svg": 2695,
	"./Seasons/027-raincoat.svg": 2696,
	"./Seasons/030-harvest.svg": 2697,
	"./Seasons/032-rainbow.svg": 2698,
	"./Seasons/033-cold.svg": 2699,
	"./Seasons/036-rainy.svg": 2700,
	"./Seasons/037-spring.svg": 2701,
	"./Seasons/038-summer.svg": 2702,
	"./Seasons/039-fall.svg": 2703,
	"./Seasons/040-winter.svg": 2704,
	"./Shops1/001-donut shop.svg": 2705,
	"./Shops1/002-ice cream shop.svg": 2706,
	"./Shops1/003-barber shop.svg": 2707,
	"./Shops1/004-bookstore.svg": 2708,
	"./Shops1/011-jewelry store.svg": 2709,
	"./Shops1/012-florist.svg": 2710,
	"./Shops1/013-restaurant.svg": 2711,
	"./Shops1/014-cafe.svg": 2712,
	"./Shops1/015-pet shop.svg": 2713,
	"./Shops1/016-pharmacy.svg": 2714,
	"./Shops1/017-pub.svg": 2715,
	"./Shops1/018-laundromat.svg": 2716,
	"./Shops1/019-boutique.svg": 2717,
	"./Shops1/021-supermarket.svg": 2718,
	"./Shops1/022-delicatessen.svg": 2719,
	"./Shops1/023-fish shop.svg": 2720,
	"./Shops2/005-gas station.svg": 2721,
	"./Shops2/024-fruit shop.svg": 2722,
	"./Shops2/026-post office.svg": 2723,
	"./Shops2/027-stationery.svg": 2724,
	"./Shops2/028-electronics shop.svg": 2725,
	"./Shops2/031-game center.svg": 2726,
	"./Shops2/032-furniture store.svg": 2727,
	"./Shops2/033-diner.svg": 2728,
	"./Shops2/034-car dealer.svg": 2729,
	"./Shops2/036-car wash.svg": 2730,
	"./Shops2/038-discount.svg": 2731,
	"./Shops2/039-warehouse.svg": 2732,
	"./Shops2/042-mall.svg": 2733,
	"./Shops2/047-bubble tea.svg": 2734,
	"./Shops2/048-repair services.svg": 2735,
	"./Shops2/049-toy store.svg": 2736,
	"./SouthAfrica/001-south africa.svg": 2737,
	"./SouthAfrica/002-boab tree.svg": 2738,
	"./SouthAfrica/003-mask.svg": 2739,
	"./SouthAfrica/005-lion.svg": 2740,
	"./SouthAfrica/006-elephant.svg": 2741,
	"./SouthAfrica/007-diamond.svg": 2742,
	"./SouthAfrica/012-soccer.svg": 2743,
	"./SouthAfrica/015-vase.svg": 2744,
	"./SouthAfrica/017-shield.svg": 2745,
	"./SouthAfrica/018-hut.svg": 2746,
	"./SouthAfrica/021-djembe.svg": 2747,
	"./SouthAfrica/026-desert.svg": 2748,
	"./SouthAfrica/037-cheetah.svg": 2749,
	"./SouthAfrica/038-giraffe.svg": 2750,
	"./SouthAfrica/049-voodoo doll.svg": 2751,
	"./SouthAfrica/050-hippo.svg": 2752,
	"./Space/0-Mars.svg": 2753,
	"./Space/0-meteorite.svg": 2754,
	"./Space/09-Earth.svg": 2755,
	"./Space/9-Jupiter.svg": 2756,
	"./Space/9-Mercury.svg": 2757,
	"./Space/9-Milky Way.svg": 2758,
	"./Space/9-Neptune.svg": 2759,
	"./Space/9-Saturn.svg": 2760,
	"./Space/9-Solar System.svg": 2761,
	"./Space/9-UFO.svg": 2762,
	"./Space/9-Uranus.svg": 2763,
	"./Space/9-Venus.svg": 2764,
	"./Space/9-moon.svg": 2765,
	"./Space/9-satellite.svg": 2766,
	"./Space/9-spaceship.svg": 2767,
	"./Space/9-sun.svg": 2768,
	"./Spring/001-bee.svg": 2769,
	"./Spring/002-humming bird.svg": 2770,
	"./Spring/003-nest.svg": 2771,
	"./Spring/006-butterflies.svg": 2772,
	"./Spring/013-flowers.svg": 2773,
	"./Spring/015-hose.svg": 2774,
	"./Spring/016-melting.svg": 2775,
	"./Spring/017-kite.svg": 2776,
	"./Spring/018-mushroom.svg": 2777,
	"./Spring/019-nest.svg": 2778,
	"./Spring/021-rain.svg": 2779,
	"./Spring/023-rainbow.svg": 2780,
	"./Spring/024-snail.svg": 2781,
	"./Spring/026-sun.svg": 2782,
	"./Spring/029-wheelbarrow.svg": 2783,
	"./Spring/030-worm.svg": 2784,
	"./Summer/001-barbecue.svg": 2785,
	"./Summer/003-beer.svg": 2786,
	"./Summer/004-camper van.svg": 2787,
	"./Summer/007-coconut.svg": 2788,
	"./Summer/010-diving googles.svg": 2789,
	"./Summer/012-ice cream.svg": 2790,
	"./Summer/014-lifeguard tower.svg": 2791,
	"./Summer/020-sun.svg": 2792,
	"./Summer/021-Sunbed.svg": 2793,
	"./Summer/022-sunscreen.svg": 2794,
	"./Summer/023-Surfboard.svg": 2795,
	"./Summer/024-swimsuit.svg": 2796,
	"./Summer/025-tent.svg": 2797,
	"./Summer/026-terrace.svg": 2798,
	"./Summer/028-watermelon.svg": 2799,
	"./Summer/029-yatch.svg": 2800,
	"./SummerHoliday1/005-airplane ticket.svg": 2801,
	"./SummerHoliday1/006-kite.svg": 2802,
	"./SummerHoliday1/007-Panama Hat.svg": 2803,
	"./SummerHoliday1/008-swimming pool.svg": 2804,
	"./SummerHoliday1/013-boat.svg": 2805,
	"./SummerHoliday1/014-road sign.svg": 2806,
	"./SummerHoliday1/015-mountains.svg": 2807,
	"./SummerHoliday1/022-ice cream cone.svg": 2808,
	"./SummerHoliday1/029-water bottle.svg": 2809,
	"./SummerHoliday1/031-life saver.svg": 2810,
	"./SummerHoliday1/032-beach chair.svg": 2811,
	"./SummerHoliday1/035-map location.svg": 2812,
	"./SummerHoliday1/036-cap.svg": 2813,
	"./SummerHoliday1/037-suitcase.svg": 2814,
	"./SummerHoliday1/038-travel bag.svg": 2815,
	"./SummerHoliday1/041-inflatable boat.svg": 2816,
	"./SummerHoliday2/001-shorts.svg": 2817,
	"./SummerHoliday2/002-ice cream bar.svg": 2818,
	"./SummerHoliday2/003-anchor.svg": 2819,
	"./SummerHoliday2/004-ice cream.svg": 2820,
	"./SummerHoliday2/009-flip flops.svg": 2821,
	"./SummerHoliday2/010-compass.svg": 2822,
	"./SummerHoliday2/011-camera.svg": 2823,
	"./SummerHoliday2/012-suitcase.svg": 2824,
	"./SummerHoliday2/019-sand castle.svg": 2825,
	"./SummerHoliday2/020-mini van.svg": 2826,
	"./SummerHoliday2/026-tent.svg": 2827,
	"./SummerHoliday2/027-umbrella.svg": 2828,
	"./SummerHoliday2/028-sunglasses.svg": 2829,
	"./SummerHoliday2/034-flippers.svg": 2830,
	"./SummerHoliday2/039-snokel and mask.svg": 2831,
	"./SummerHoliday2/040-trailer.svg": 2832,
	"./SuperHero/002-Ant Man.svg": 2833,
	"./SuperHero/003-Black Panther.svg": 2834,
	"./SuperHero/004-Black Widow.svg": 2835,
	"./SuperHero/005-Captain America.svg": 2836,
	"./SuperHero/006-Deadpool.svg": 2837,
	"./SuperHero/008-Doctor Strange.svg": 2838,
	"./SuperHero/012-Groot.svg": 2839,
	"./SuperHero/013-Hawkege.svg": 2840,
	"./SuperHero/014-Hulk.svg": 2841,
	"./SuperHero/015-Iron Man.svg": 2842,
	"./SuperHero/016-Loki.svg": 2843,
	"./SuperHero/019-Nick Fury.svg": 2844,
	"./SuperHero/021-Rocket Raccoon.svg": 2845,
	"./SuperHero/022-Spider Man.svg": 2846,
	"./SuperHero/026-Thor.svg": 2847,
	"./SuperHero/029-Winter Soldier.svg": 2848,
	"./Supermarket/002-payment.svg": 2849,
	"./Supermarket/004-bread.svg": 2850,
	"./Supermarket/007-cash register.svg": 2851,
	"./Supermarket/010-corn.svg": 2852,
	"./Supermarket/011-eggs.svg": 2853,
	"./Supermarket/014-refrigerator.svg": 2854,
	"./Supermarket/016-milk.svg": 2855,
	"./Supermarket/019-receipt.svg": 2856,
	"./Supermarket/020-shopping bag.svg": 2857,
	"./Supermarket/022-shopping basket.svg": 2858,
	"./Supermarket/023-shopping cart.svg": 2859,
	"./Supermarket/024-strawberry jam.svg": 2860,
	"./Supermarket/025-supermarket.svg": 2861,
	"./Supermarket/026-clerk.svg": 2862,
	"./Supermarket/027-tag.svg": 2863,
	"./Supermarket/029-scale.svg": 2864,
	"./Technology1/001-robotic arm.svg": 2865,
	"./Technology1/002-fingerprint.svg": 2866,
	"./Technology1/003-Virtual glasses.svg": 2867,
	"./Technology1/004-smart house.svg": 2868,
	"./Technology1/009-smartwatch.svg": 2869,
	"./Technology1/010-drone.svg": 2870,
	"./Technology1/011-Virtual glasses.svg": 2871,
	"./Technology1/012-camera.svg": 2872,
	"./Technology1/017-microprocessor.svg": 2873,
	"./Technology1/018-flash drive.svg": 2874,
	"./Technology1/019-usb connector.svg": 2875,
	"./Technology1/020-laptop.svg": 2876,
	"./Technology1/025-game controller.svg": 2877,
	"./Technology1/026-printer.svg": 2878,
	"./Technology1/036-speaker.svg": 2879,
	"./Technology1/041-projector.svg": 2880,
	"./Technology2/005-mobile payment.svg": 2881,
	"./Technology2/007-autonomous car.svg": 2882,
	"./Technology2/014-cctv.svg": 2883,
	"./Technology2/030-face recognition.svg": 2884,
	"./Technology2/031-hologram.svg": 2885,
	"./Technology2/032-3d printer.svg": 2886,
	"./Technology2/038-blender.svg": 2887,
	"./Technology2/039-microwave.svg": 2888,
	"./Technology2/040-radio antenna.svg": 2889,
	"./Technology2/043-phone.svg": 2890,
	"./Technology2/044-mouse.svg": 2891,
	"./Technology2/045-keyboard.svg": 2892,
	"./Technology2/046-touch screen.svg": 2893,
	"./Technology2/047-microphone.svg": 2894,
	"./Technology2/048-battery.svg": 2895,
	"./Technology2/049-robot.svg": 2896,
	"./Thailand/002-pagoda.svg": 2897,
	"./Thailand/003-temple.svg": 2898,
	"./Thailand/004-boat.svg": 2899,
	"./Thailand/005-boxing ring.svg": 2900,
	"./Thailand/010-durian.svg": 2901,
	"./Thailand/012-jasmine.svg": 2902,
	"./Thailand/018-monk.svg": 2903,
	"./Thailand/019-monkey.svg": 2904,
	"./Thailand/020-muay thai.svg": 2905,
	"./Thailand/021-pad thai.svg": 2906,
	"./Thailand/022-palace.svg": 2907,
	"./Thailand/024-stall food.svg": 2908,
	"./Thailand/026-flags.svg": 2909,
	"./Thailand/027-house.svg": 2910,
	"./Thailand/029-tom yum.svg": 2911,
	"./Thailand/030-Tuk tuk.svg": 2912,
	"./Thanksgiving/001-turkey.svg": 2913,
	"./Thanksgiving/002-barrel.svg": 2914,
	"./Thanksgiving/003-bread.svg": 2915,
	"./Thanksgiving/012-apples.svg": 2916,
	"./Thanksgiving/018-cider.svg": 2917,
	"./Thanksgiving/022-oil lamp.svg": 2918,
	"./Thanksgiving/025-candle.svg": 2919,
	"./Thanksgiving/027-Native American.svg": 2920,
	"./Thanksgiving/033-pray.svg": 2921,
	"./Thanksgiving/034-turkey.svg": 2922,
	"./Thanksgiving/035-pie.svg": 2923,
	"./Thanksgiving/036-corn.svg": 2924,
	"./Thanksgiving/039-place setting.svg": 2925,
	"./Thanksgiving/041-barn.svg": 2926,
	"./Thanksgiving/047-gravy.svg": 2927,
	"./Thanksgiving/049-fireplace.svg": 2928,
	"./Toys/003-Jigsaw.svg": 2929,
	"./Toys/004-remote control.svg": 2930,
	"./Toys/005-robot.svg": 2931,
	"./Toys/006-rocking horse.svg": 2932,
	"./Toys/007-rubik cube.svg": 2933,
	"./Toys/008-toy boat.svg": 2934,
	"./Toys/010-teddy bear.svg": 2935,
	"./Toys/012-walkie talkie.svg": 2936,
	"./Toys/013-xylophone.svg": 2937,
	"./Toys/015-balloons.svg": 2938,
	"./Toys/017-toy car.svg": 2939,
	"./Toys/019-dice.svg": 2940,
	"./Toys/023-beach ball.svg": 2941,
	"./Toys/024-abacus.svg": 2942,
	"./Toys/033-baby mobile.svg": 2943,
	"./Toys/034-rubber duck.svg": 2944,
	"./Transportation/001-airplane.svg": 2945,
	"./Transportation/003-hot air balloon.svg": 2946,
	"./Transportation/004-bicycle.svg": 2947,
	"./Transportation/005-blimp.svg": 2948,
	"./Transportation/006-bus.svg": 2949,
	"./Transportation/008-car.svg": 2950,
	"./Transportation/012-truck.svg": 2951,
	"./Transportation/013-drone.svg": 2952,
	"./Transportation/014-helicopter.svg": 2953,
	"./Transportation/016-rocket.svg": 2954,
	"./Transportation/017-sailboat.svg": 2955,
	"./Transportation/018-Segway.svg": 2956,
	"./Transportation/019-ship.svg": 2957,
	"./Transportation/022-tractor.svg": 2958,
	"./Transportation/024-train.svg": 2959,
	"./Transportation/025-delivery truck.svg": 2960,
	"./Travel/002-luggage.svg": 2961,
	"./Travel/003-backpack.svg": 2962,
	"./Travel/004-gps.svg": 2963,
	"./Travel/007-motorcycle.svg": 2964,
	"./Travel/008-taxi.svg": 2965,
	"./Travel/012-airplane.svg": 2966,
	"./Travel/013-ticket.svg": 2967,
	"./Travel/014-explorer hat.svg": 2968,
	"./Travel/015-camera.svg": 2969,
	"./Travel/016-power bank.svg": 2970,
	"./Travel/018-compass.svg": 2971,
	"./Travel/023-passport.svg": 2972,
	"./Travel/026-airport.svg": 2973,
	"./Travel/030-bus.svg": 2974,
	"./Travel/040-cruise.svg": 2975,
	"./Travel/048-road sign.svg": 2976,
	"./USA/005-burger.svg": 2977,
	"./USA/006-eagle.svg": 2978,
	"./USA/007-Grand Canyon.svg": 2979,
	"./USA/008-Statue of Liberty.svg": 2980,
	"./USA/009-moon.svg": 2981,
	"./USA/011-cowboy.svg": 2982,
	"./USA/012-Golden Gate Bridge.svg": 2983,
	"./USA/013-Empire State Building.svg": 2984,
	"./USA/014-Washington Monument.svg": 2985,
	"./USA/015-road.svg": 2986,
	"./USA/016-the Oscars.svg": 2987,
	"./USA/017-American football.svg": 2988,
	"./USA/018-Native American.svg": 2989,
	"./USA/021-police.svg": 2990,
	"./USA/023-astronaut.svg": 2991,
	"./USA/024-Abraham Lincoln.svg": 2992,
	"./ValentinesDay/001-heart.svg": 2993,
	"./ValentinesDay/003-cupid arrow.svg": 2994,
	"./ValentinesDay/004-love letter.svg": 2995,
	"./ValentinesDay/007-balloons.svg": 2996,
	"./ValentinesDay/010-bracelet.svg": 2997,
	"./ValentinesDay/012-chocolate box.svg": 2998,
	"./ValentinesDay/018-cruise.svg": 2999,
	"./ValentinesDay/020-cupcake.svg": 3000,
	"./ValentinesDay/025-rings.svg": 3001,
	"./ValentinesDay/027-pendant.svg": 3002,
	"./ValentinesDay/029-champagne.svg": 3003,
	"./ValentinesDay/030-romantic dinner.svg": 3004,
	"./ValentinesDay/032-padlock.svg": 3005,
	"./ValentinesDay/038-perfume.svg": 3006,
	"./ValentinesDay/039-teddy bear.svg": 3007,
	"./ValentinesDay/045-romantic movie.svg": 3008,
	"./Vegetable1/001-tomato.svg": 3009,
	"./Vegetable1/002-lettuce.svg": 3010,
	"./Vegetable1/003-corn.svg": 3011,
	"./Vegetable1/009-mango.svg": 3012,
	"./Vegetable1/010-potatoes.svg": 3013,
	"./Vegetable1/011-coconut.svg": 3014,
	"./Vegetable1/017-peas.svg": 3015,
	"./Vegetable1/018-cucumber.svg": 3016,
	"./Vegetable1/019-kiwi.svg": 3017,
	"./Vegetable1/027-avocado.svg": 3018,
	"./Vegetable1/031-spring onion.svg": 3019,
	"./Vegetable1/035-olives.svg": 3020,
	"./Vegetable1/039-carrot.svg": 3021,
	"./Vegetable1/042-cabbage.svg": 3022,
	"./Vegetable1/044-zucchini.svg": 3023,
	"./Vegetable1/050-garlic.svg": 3024,
	"./Vegetable2/006-eggplant.svg": 3025,
	"./Vegetable2/007-ginger.svg": 3026,
	"./Vegetable2/008-pumpkin.svg": 3027,
	"./Vegetable2/012-carambola.svg": 3028,
	"./Vegetable2/013-horseradish.svg": 3029,
	"./Vegetable2/020-broccoli.svg": 3030,
	"./Vegetable2/021-asparagus.svg": 3031,
	"./Vegetable2/022-peanut.svg": 3032,
	"./Vegetable2/023-pepper.svg": 3033,
	"./Vegetable2/028-radish.svg": 3034,
	"./Vegetable2/029-parsley.svg": 3035,
	"./Vegetable2/030-cabbage.svg": 3036,
	"./Vegetable2/036-onion.svg": 3037,
	"./Vegetable2/037-mushroom.svg": 3038,
	"./Vegetable2/038-artichoke.svg": 3039,
	"./Vegetable2/047-chili pepper.svg": 3040,
	"./Vehicles/001-ambulance.svg": 3041,
	"./Vehicles/003-bus.svg": 3042,
	"./Vehicles/006-cement truck.svg": 3043,
	"./Vehicles/010-fire truck.svg": 3044,
	"./Vehicles/012-food truck.svg": 3045,
	"./Vehicles/014-golf cart.svg": 3046,
	"./Vehicles/015-jeep.svg": 3047,
	"./Vehicles/017-motorcycle.svg": 3048,
	"./Vehicles/018-pickup truck.svg": 3049,
	"./Vehicles/019-police car.svg": 3050,
	"./Vehicles/022-sport car.svg": 3051,
	"./Vehicles/026-tank.svg": 3052,
	"./Vehicles/027-taxi.svg": 3053,
	"./Vehicles/028-tow truck.svg": 3054,
	"./Vehicles/029-truck.svg": 3055,
	"./Vehicles/030-Tuk tuk.svg": 3056,
	"./Weather/001-sun.svg": 3057,
	"./Weather/003-snowflake.svg": 3058,
	"./Weather/004-thermometer.svg": 3059,
	"./Weather/006-half moon.svg": 3060,
	"./Weather/007-wind.svg": 3061,
	"./Weather/008-raindrop.svg": 3062,
	"./Weather/010-storm.svg": 3063,
	"./Weather/012-rainbow.svg": 3064,
	"./Weather/013-tornado.svg": 3065,
	"./Weather/015-eclipse.svg": 3066,
	"./Weather/017-rain.svg": 3067,
	"./Weather/018-rain.svg": 3068,
	"./Weather/019-thunderbolt.svg": 3069,
	"./Weather/020-snow.svg": 3070,
	"./Weather/021-sunset.svg": 3071,
	"./Weather/026-moon.svg": 3072,
	"./Weekend/002-camping.png": 3073,
	"./Weekend/004-playing chess.png": 3074,
	"./Weekend/005-watching movies.png": 3075,
	"./Weekend/006-cooking.png": 3076,
	"./Weekend/011-fishing.png": 3077,
	"./Weekend/012-gaming.png": 3078,
	"./Weekend/013-gardening.png": 3079,
	"./Weekend/014-grilling.png": 3080,
	"./Weekend/015-singing karaoke.png": 3081,
	"./Weekend/016-flying kite.png": 3082,
	"./Weekend/023-reading.png": 3083,
	"./Weekend/025-sunbathing.png": 3084,
	"./Weekend/026-swimming.png": 3085,
	"./Weekend/028-weightlifting.png": 3086,
	"./Weekend/029-woodworking.png": 3087,
	"./Weekend/030-writing.png": 3088,
	"./Winter1/001-sweater.svg": 3089,
	"./Winter1/003-puffer coat.svg": 3090,
	"./Winter1/004-coat.svg": 3091,
	"./Winter1/007-winter hat.svg": 3092,
	"./Winter1/008-santa hat.svg": 3093,
	"./Winter1/009-earmuffs.svg": 3094,
	"./Winter1/010-headband.svg": 3095,
	"./Winter1/011-scarf.svg": 3096,
	"./Winter1/012-sock.svg": 3097,
	"./Winter1/013-mittens.svg": 3098,
	"./Winter1/014-boot.svg": 3099,
	"./Winter1/015-ice skate.svg": 3100,
	"./Winter1/021-snowflake.svg": 3101,
	"./Winter1/027-snowy.svg": 3102,
	"./Winter1/028-blizzard.svg": 3103,
	"./Winter1/029-hail.svg": 3104,
	"./Winter2/017-igloo.svg": 3105,
	"./Winter2/018-fireplace.svg": 3106,
	"./Winter2/023-bonfire.svg": 3107,
	"./Winter2/026-cold.svg": 3108,
	"./Winter2/030-avalanche.svg": 3109,
	"./Winter2/037-snowman.svg": 3110,
	"./Winter2/038-gingerbread man.svg": 3111,
	"./Winter2/041-ice hockey.svg": 3112,
	"./Winter2/042-snowboard.svg": 3113,
	"./Winter2/043-skis.svg": 3114,
	"./Winter2/044-snow globe.svg": 3115,
	"./Winter2/045-matches.svg": 3116,
	"./Winter2/046-teapot.svg": 3117,
	"./Winter2/047-hot chocolate.svg": 3118,
	"./Winter2/048-hot tea.svg": 3119,
	"./Winter2/050-cookie & milk.svg": 3120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3125;